import React, { useEffect, useRef, useState } from 'react';
import {
  MotifFileUploader, MotifButton, MotifFormField, MotifIcon, MotifProgressLoader, MotifInput, MotifProgressBar,
  MotifLabel,
  MotifErrorMessage,
  MotifToast

} from "@ey-xd/motif-react";
import JSZip from "jszip";
import { apiQueryToUploadDataRegional, apiQueryWithToken } from "../../common/services/apiBaseUrlConfig";
import { getAccount } from "../../common/services/commonService";
import { v4 as uuidv4, validate } from 'uuid';
import { deleteIcon, eyeCloseIcon, eyeIcon, greyLockIcon, lockIcon, passwordCursorIcon, sharePointIcon } from '../../common/MotifIcons';
import MotifSearch from '@ey-xd/motif-react/Search';
import ProtectedFilesDisplay from './ProtectedFilesDisplay';
import FileTile from './FileTile';
import ProgressCircle from './ProgressCircle';
import BreadcrumbNavigation from './BreadcrumbNavigation';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { BlockBlobClient } from '@azure/storage-blob';
import pLimit from 'p-limit';
import { countEffectiveFiles, getMimeType, addToStructure, countFilesRecursively } from '../../common/utility/utility';
import useGetApplicationData from '../../common/redux/common/getApplicationData/useGetApplicationData';
import { getPartnerFilesBlocklistData, getPartnersFileValidationAU, getPartnersFileValidationEU, getPartnersFileValidationUS, partnersSasTokenAU, partnersSasTokenEU, partnersSasTokenUS, partnersUploadProcessingUS, partnersUploadProcessingEU, partnersUploadProcessingAU, partnersUploadReProcessingUS, partnersUploadReProcessingEU, partnersUploadReProcessingAU, partnersUploadedFileStatusRequestUS, partnersUploadedFileStatusRequestEU, partnersUploadedFileStatusRequestAU, partnersDuplicateFilesRequestUS, partnersDuplicateFilesRequestEU, partnersDuplicateFilesRequestAU, partnersErrorSaveDataRequest } from './redux/partnerFileUploadSlice';
import { ApiStatus } from '../../common/services/api-status.enum';
import usePartnerFileUpload from './hooks/usePartnerFileUpload';
import { FailedUploadsList } from './FailedUploadsList'
import { useDispatch } from 'react-redux';
import { AMERICAS, APAC, EMEIA, UNITED_KINGDOM } from '../../common/contants/constants';
import SelectSharePoint from './SelectSharePoint';
import { useMsal } from "@azure/msal-react";
import { resolveSharePointLink, fetchSharePointFiles, SPAccessError } from './SPUtility';
import SmallCircleLoader from './SmallCircleLoader';
import NetworkStatus from '../network-status/networkStatus';

import './partnerFileUpload.scss';
import logger from "../../common/utils/logger";
import { appendGicsUploadFields, resolveGicsSelection, toGicsUploadPayload } from './gicsSectorUtils';

export const ClientEngagementUploader = ({ onClose, rowData, totalFileCount, setFileCount, triggerEngagementUpdate, isClientEngagement, failedUploads, setFailedUploads, handleRemoveFile, openFailedUploadBadge, uploadPercentage, setUploadPercentage, failedUploadData, setFailedUploadLoadData, isFailedUploadLoadData, initiateAutoProcess, engagementPauseStatus, setAllProtectedFilesCount, onClientDataChange, setAlertMessage, setOpenAlertDialog }) => {
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [isLargeZipFile, setIsLargeZipFile] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [baseURL, setBaseURL] = useState("");
  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  const [isSkipContinueClicked, setIsSkipContinueClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const userProfileDetails = JSON.parse(sessionStorage.getItem("profileDetails"));
  const [isUploading, setIsUploading] = useState(false);
  const [fileProtectionStatus, setFileProtectionStatus] = useState({}); // New state for protection status
  const [protectedFiles, setProtectedFiles] = useState([]);
  const [showProgressPage, setShowProgressPage] = useState(false);
  const [passwords, setPasswords] = useState({});
  const [isCorrectpasswords, setIsCorrectPasswords] = useState({});
  const [showErrorMessage, setshowErrorMessage] = useState({});
  const [fileStructure, setFileStructure] = useState({});
  const [currentPath, setCurrentPath] = useState([]);
  const [shoWBreadcrumb, setshoWBreadcrumb] = useState(false);
  const [extractedFiles, setExtractedFiles] = useState([]);  
  const [isUnlocking, setIsUnlocking] = useState(false);
  const [pageReload, setPageReload] = useState(false);
  const [blockedFileList, setBlockedFileList] = useState([]);
  const [attemptedBlockedFiles, setAttemptedBlockedFiles] = useState([]);
  const [showProgress, setShowProgress] = useState([]);
  const [isValidFile, setIsValidFile] = useState(false);
  const [allProtectedFiles, setAllProtectedFiles] = useState([]);
  const [uploadComplete, SetUploadComplete] = useState(false);
  const [engLevelPwd, setEngLevelPwd] = useState("");
  const [failedDeleteLoading, setFailedDeleteLoading] = useState(false);
  const duplicateFiles = useRef([]);
  const submittedDuplicateFiles = useRef(false);
  const nonsubmittedDuplicateFiles = useRef(false);
  const [openDuplicateDialog, setOpenDuplicateDialog] = useState(false);
  const overrideFiles = useRef(false);
  const deletedFileKeys = useRef(new Set());
  // Stores the original total for the current upload session so the circle
  // denominator never changes when files are deleted (avoids state-batching race).
  const originalTotalCountRef = useRef(0);
  // Peak failedCount, never decremented — used only for the "X file failed!"
  // display text so it stays at the initial total after deletes/re-uploads.
  const initialFailedCountRef = useRef(0);
  // ControlIds of blob-failure (Type 1) files re-uploaded via generateMetadata.
  // Their uploaded/failed counts are already adjusted by updateUploadedCount, so
  // the reprocess-complete handler must NOT adjust them again (avoids double count).
  const retryMetadataControlIds = useRef(new Set());
  // During "Re-upload all", blob-failure files are uploaded first; generateMetadata
  // collects their freshly generated controlIds here instead of reprocessing each
  // one, so they can be reprocessed together in a single UploadReProcessing call.
  const bulkReprocessMode = useRef(false);
  const bulkReprocessControlIds = useRef([]);

  // Update parent component with allProtectedFiles count
  useEffect(() => {
    if (setAllProtectedFilesCount) {
      setAllProtectedFilesCount(uploadComplete && !showProgressPage);
    }
  }, [allProtectedFiles, setAllProtectedFilesCount]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [sortCode, SetSortCode] = React.useState("");
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [uploadingFileId, setUploadingFileId] = useState(null); // single
  const [uploadingFileIds, setUploadingFileIds] = useState([]); // bulk
  const [isDragging, setIsDragging] = useState(false);
  const [showError, setShowError] = useState({});
  const [fileEvaluatingMsg, setFileEvaluatingMsg] = useState(false);
  const [evaluationProgress, setEvaluationProgress] = useState(0);
  const [openDialogbox, setOpenDialogbox] = React.useState(false);
  const [selectedSPFiles, SetSelectedSPFiles] = useState([]);
  const [handleAttach, SetHandleAttach] = useState(false);
  const [uploadedControlIDs, SetUploadedControlIDs] = useState([]);
  const [startProcessImmediately, SetStartProcessImmediately] = useState(false);
  const [showProcessingPage, setShowProcessingPage] = useState(false);
  const [isSPFileUpload, setIsSPFileUpload] = useState(false);
  const [disableContinue, setDisableContinue] = useState(false);
  const [totalFileProcessed, setTotalFileProcessed] = useState(0);
  const [totalFileUploaded, setTotalFileUploaded] = useState(0);
  const [totalFileFailed, setTotalFileFailed] = useState(0);
  const [processingResult, setProcessingResult] = useState(false);
  const [isCorrectPassword, setIsCorrectPassword] = useState({});
  let ValidFile = false;
  const [sharePointURL, setSharePointURL] = useState("");
  const [buttonLabel, setButtonLabel] = useState("Proceed");
  const [SPPayload, setSPPayload] = useState({});
  const [SPAccess, setSPAccess] = useState(null);
  const { instance, accounts } = useMsal();
  const [sharePointFiles, setSharePointFiles] = useState([]);
  const [SPSSiteData, setSPSSiteData] = useState(null);
  const [SPToken, setSPToken] = useState(null);
  // Holds the driveId/folderId resolved for the current sharePointURL (fast,
  // link-validation-only step) so handleSPProceedClick can later walk the
  // folder tree without re-resolving the link.
  const [spResolvedFolder, setSpResolvedFolder] = useState(null);
  const [isSPLoading, setIsSPLoading] = useState(false);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const [showUploadData, setShowUploadData] = useState(false);
  const SNSTransactionID = useRef([]);
  const [nextPwdPage, setNextPwdPage] = useState(true);
  const [isEngLevelPasswordVisible, setIsEngLevelPasswordVisible] = useState(false);
  const pwdSkipped = useRef(false);
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();
  const { getApplicationDetail } = useGetApplicationData();
  const { utilityData, partnerFilesBlocklistData, partnersFileValidationData, partnersUploadProcessingData, partnersUploadReProcessingData, partnersUploadedFileStatusData, partnersDuplicateFilesData } = usePartnerFileUpload();
  const [processingErrorStatus, setProcessingErrorStatus] = useState(null);
  const [processingMsg, setProcessingMsg] = useState(false);

  const generateGUID = () => {
    const guid = uuidv4();
    return guid;
  };
  const [UPLOADID_GUID, setUploadGuid] = useState(generateGUID());

  useEffect(() => {
    const maxProgress = 93;

    const interval = setInterval(() => {
      setEvaluationProgress((prevProgress) => {
        const randomIncrement = Math.floor(Math.random() * 3) + 1; // Random number between 1 and 3
        const newProgress = Math.min(prevProgress + randomIncrement, maxProgress); // Ensure it doesn't exceed 86%
        return newProgress;
      });
    }, 15000); // Update every 30 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  useEffect(() => {
    if (failedUploads.length > 0 && processingMsg) {
      setProcessingMsg(false);
    }
  }, [failedUploads.length]);
  useEffect(() => {
    if (SPSSiteData?.id) {
      setIsToastVisible(true);
      setTimeout(() => {
        setIsToastVisible(false);
      }, 5000);
    }
  }, [SPSSiteData])
  const spFilesSizeGB = files.filter(file => file?.isSPFile).reduce((total, file) => total + (Number(file.size) || 0), 0) / (1024 * 1024 * 1024);

  const prevSharePointURL = useRef("");
  /* istanbul ignore next */
  const handleSPProceedClick = async () => {
    setButtonLabel("Update");

    if (prevSharePointURL.current && sharePointURL && prevSharePointURL.current !== sharePointURL) {
      setFiles(prevFiles => prevFiles.filter(file => !file.isSPFile));
    }
    prevSharePointURL.current = sharePointURL;

    if (!SPSSiteData?.id || !spResolvedFolder) return;

    // Folder tree was already walked for this link (e.g. Proceed clicked
    // again without changing the URL) -- no need to re-fetch.
    if (sharePointFiles.length > 0) {
      setOpenDialogbox(true);
      return;
    }

    setIsSPLoading(true);
    try {
      const AllFilesData = await fetchSharePointFiles(
        spResolvedFolder.driveId,
        spResolvedFolder.folderId,
        SPToken
      );
      setSharePointFiles(AllFilesData);
      setOpenDialogbox(true);
    } catch (error) {
      if (error instanceof SPAccessError) {
        setSPAccess(false);
      } else {
        setAlertMessage("Please provide a valid Folder/File link");
        setOpenAlertDialog(true);
      }
    } finally {
      setIsSPLoading(false);
    }
  };
  useEffect(() => {
    if (sharePointURL?.length > 0) {
      setIsSPLoading(true); // Start loading before validating
      setSharePointFiles([]);
      setSpResolvedFolder(null);
      // A new link hasn't been proceeded with yet -- don't carry over the
      // "Update" label from a previously-proceeded link.
      setButtonLabel("Proceed");
      const validateSPLink = async () => {
        try {
          const { folderMetadata, driveId, siteData, token } = await resolveSharePointLink(
            sharePointURL,
            instance,
            accounts
          );
          setSPAccess(true);
          setSPSSiteData(siteData);
          setSPToken(token);
          setSpResolvedFolder({ driveId, folderId: folderMetadata.id });
        } catch (error) {
          if (error instanceof SPAccessError) {
            setSPAccess(false);
          } else {
            setAlertMessage("Please provide a valid Folder/File link");
            setOpenAlertDialog(true);
            setSPAccess(null);
          }

        } finally {
          setIsSPLoading(false);
        }
      };
      validateSPLink();
    }
  }, [sharePointURL]);
  /* istanbul ignore next */
  function transformSharePointFile(spFile) {
    // Extract the parent path, removing 'root:' and leading slashes
    const parentPath = spFile.parentReference?.path
      ? spFile.parentReference.path.replace(/.*root:/, "").replace(/^\/+/, "")
      : "";

    return {
      name: spFile.name || spFile.file?.name,
      size: spFile.size || spFile.file?.size || 0,
      type: spFile.file?.mimeType || spFile?.mimeType || "",
      lastModified: new Date(spFile.lastModifiedDateTime).getTime(),
      id: spFile.id,
      path: parentPath
        ? `${parentPath}/${spFile.name}`
        : spFile.name,
      isSPFile: true
      // any additional custom fields can be added here
    };
  }
  /* istanbul ignore next */
  useEffect(() => {
    let SPFiles = [];
    if (handleAttach == true) {

      // for (let file in selectedSPFiles) {

      // }
      selectedSPFiles.map(item => {
        SPFiles.push(transformSharePointFile(item));
      })
      onDrop(SPFiles);
    }
  }, [handleAttach]);

  /* istanbul ignore next */
  const handleToggleSelect = (fileId) => {
    setSelectedFiles((prev) =>
      prev.includes(fileId)
        ? prev.filter((id) => id !== fileId)
        : [...prev, fileId]
    );
  };

  /* istanbul ignore next */
  const handleToggleSelectAll = () => {
    if (selectedFiles.length === failedUploads.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(failedUploads.map((file) => file.id));
    }
  };

  /* istanbul ignore next */
  const showProgressBarFailedUpload = (value) => {
    setIsActive(value);
  };

  /* istanbul ignore next */
  const handleReupload = async (id) => {
    setDisableContinue(true);
    setUploadingFileId(id);

    const fileToReupload = failedUploads.find((file) => file.id === id);
    const filesToUpload = [fileToReupload.file];
    try {
      const fileEntry = failedUploads.find(f => f.id === id);
      const isFileBlocked = String(fileEntry?.errorCode) === "1003";
      if (!isFileBlocked && fileEntry?.attempts < 3) {
        let uploadResult;
        if (fileToReupload?.batchStatus === "Processing" && fileToReupload.id === id) {
          const controlId = fileToReupload?.controlId;
          const response = await initiateReProcess([controlId]);
        } else {
          uploadResult = await UploadFolders(filesToUpload, true, fileToReupload.id);
        }


        const isFulfilled = uploadResult?.[0]?.status === "fulfilled";
        const isEmptyArray = Array.isArray(uploadResult?.[0]?.value) && uploadResult[0].value.length === 0;
        const isUndefinedValue = typeof uploadResult?.[0]?.value === "undefined";

        if (isFulfilled) {
          const remainingAfterReupload = failedUploads.filter(
            (file) => file.id !== id
          ).length;
          if (remainingAfterReupload === 0) {
            setProcessingMsg(true);
          }
        }
        // Treat both empty array and undefined value as success
        if (isFulfilled && failedUploads.length === 0) {
          // State was already updated by updateUploadedCount inside generateMetadata.
          // Mutating progress here would target a stale object — do not duplicate.
          // ✅ Upload success AND empty array: remove from failedUploads and selectedFiles
          setFailedUploads((prev) => prev.filter((file) => file.id !== id));
          setSelectedFiles((prev) => prev.filter((fileId) => fileId !== id));
          // setShowProcessingPage(false);
          setDisableContinue(false);
          const formData = {
            transactionID: id,
            isReUpload: true,
            ErrorIds: [],
            EmailAddress: getAccount()?.username,
            EngagementIdGUID: rowData?.engagementId_GUID || null,
            deleteLog: true
          }
          await DeleteReUploadErrorLog(formData);
          // Trigger reprocessing for the successfully reuploaded file.
          if (fileToReupload?.controlId) {
            await initiateReProcess([fileToReupload.controlId]);
          }
          // if (fileToReupload?.batchStatus === "Processing") {
          //   const formData = {
          //     transactionID: fileToReupload?.transactionID || "",
          //     isReUpload: true,
          //     ErrorIds: [id],
          //     EmailAddress: getAccount()?.username,
          //     EngagementIdGUID: rowData?.engagementId_GUID || null,
          //     deleteLog: true
          //   }
          //   await DeleteReUploadErrorLog(formData);
          // }

        } else {
          /* setShowProcessingPage(false);
           setDisableContinue(false);
           setFailedUploads((prev) =>
             prev.map((file) =>
               file.id === id ? { ...file, attempts: file.attempts + 1 } : file
             )
           );*/

        }
      }
    } catch (error) {
      logger.error("Upload failed:", error);

      setFailedUploads((prev) =>
        prev.map((file) =>
          file.id === id ? { ...file, attempts: file.attempts + 1 } : file
        )
      );
    } finally {
      // setUploadingFileId(null);
    }
  };
  const retryState = useRef({ total: 0, completed: 0 });
  // True while a re-upload flow is running so the auto-process useEffect does
  // not fire initiateProcess (retries use initiateReProcess instead).
  const isReuploadFlow = useRef(false);
  /* istanbul ignore next */
  const handleReuploadAll = async () => {

    setDisableContinue(true);
    if (selectedFiles.length === 0) return;

    const isReuploadBlocked = (file) => String(file.errorCode) === "1003";

    // Filter files eligible for re-upload (attempts < 3, not corrupt, not errorCode 1003)
    const filesToReupload = failedUploads.filter(
      (file) => selectedFiles.includes(file.id) && file.attempts < 3 && !isReuploadBlocked(file)
    );

    // Log or notify about files that are blocked due to 3+ attempts
    const blockedFiles = failedUploads.filter(
      (file) => selectedFiles.includes(file.id) && file.attempts >= 3
    );

    if (blockedFiles.length > 0) {
      logger.warn("These files have reached the maximum upload attempts and will be skipped:", blockedFiles);
      // Optional: Show toast/snackbar in UI
      // showToast("Some files were skipped as they reached the maximum upload attempts.");
    }

    if (filesToReupload.length === 0) return;

    const filesToUpload = filesToReupload.map((file) => file.file);
    const idsUploading = filesToReupload.map((file) => file.id);
    setUploadingFileIds(idsUploading);



    let isProcessingPath = false;
    try {
      // Files that already have a controlId (blob uploaded OK, only failed at
      // processing) are reprocessed directly. Files without a controlId failed at
      // blob upload and must be re-uploaded first (blob -> metadata) to obtain a
      // fresh controlId. All resulting controlIds are then reprocessed together in
      // a single UploadReProcessing call.
      const filesWithControlId = filesToReupload.filter(file => file?.controlId);
      const filesNeedingUpload = filesToReupload.filter(file => !file?.controlId);
      const existingControlIds = filesWithControlId.map(file => String(file.controlId));

      // Re-upload blob-failure files first, collecting their new controlIds
      // instead of reprocessing each one individually.
      bulkReprocessControlIds.current = [];
      if (filesNeedingUpload.length > 0) {
        bulkReprocessMode.current = true;
        retryState.current.total = filesNeedingUpload.length;
        retryState.current.completed = 0;
        try {
          for (const file of filesNeedingUpload) {
            await handleReupload(file.id);
          }
        } finally {
          bulkReprocessMode.current = false;
        }
      }

      const allControlIds = [...existingControlIds, ...bulkReprocessControlIds.current];

      // Reprocess every re-uploaded file in one go.
      if (allControlIds.length > 0) {
        // initiateReProcess only dispatches a Redux action and returns
        // immediately; the actual result arrives via partnersUploadReProcessingData
        // which resets uploadingFileIds. Do NOT clear it in finally here or the
        // loader would disappear instantly before reprocess completes.
        isProcessingPath = true;
        await initiateReProcess(allControlIds);
      }
      // if (processingResult === true) {
      //   const updated = failedUploads.filter((file) => !selectedFiles.includes(file.id));

      //   setFailedUploads(updated);
      //   setSelectedFiles((prev) => prev.filter((fileId) => !selectedFiles.includes(fileId)));
      //   const formData = {
      //     transactionID: filesToReupload?.find(file => file.id === idsUploading[0])?.transactionID || "",
      //     isReUpload: true,
      //     ErrorIds: [...idsUploading],
      //     EmailAddress: getAccount()?.username,
      //     EngagementIdGUID: rowData?.engagementId_GUID || null,
      //     deleteLog: true
      //   }
      //   await DeleteReUploadErrorLog(formData);
      // }
      // for (const file of filesToReupload) {
      //   await handleReupload(file.id);
      // }
    } catch (error) {
      logger.error("Bulk upload failed:", error);

    } finally {
      // For the processing path, partnersUploadReProcessingData clears the loader
      // once reprocess actually completes; clearing here would hide it too early.
      if (!isProcessingPath) {
        setUploadingFileIds([]);
      }
    }
  };
  /* istanbul ignore next */
  const rememberDeletedFile = (deletedFile) => {
    if (!deletedFile) return;
    if (deletedFile.id) deletedFileKeys.current.add(deletedFile.id);
    if (deletedFile.controlId) deletedFileKeys.current.add(deletedFile.controlId);
    if (deletedFile.transactionID) deletedFileKeys.current.add(deletedFile.transactionID);
  };

  /* istanbul ignore next */
  // count            = total files being deleted
  // processingCount  = how many of those had a controlId (blob uploaded OK but
  //                    failed at server processing, so they were already counted
  //                    in uploadedCount via generateMetadata)
  const decrementFailedCount = (count, processingCount = 0) => {
    if (count <= 0) return;
    setUploadPercentage((prev) => {
      const current = prev[rowData.engagementId];
      if (!current) return prev;

      const failedCount   = Math.max(0, (current.failedCount   || 0) - count);
      const totalCount    = Math.max(0, (current.totalCount    || 0) - count);
      // Processing-failed files were already counted in uploadedCount by
      // generateMetadata, so decrement uploadedCount for those.
      const uploadedCount = Math.min(
        Math.max(0, (current.uploadedCount || 0) - processingCount),
        totalCount
      );
      const percent = totalCount > 0
        ? Math.min(100, Math.round((uploadedCount + failedCount) / totalCount * 100))
        : 100;

      const updated = { ...current, failedCount, totalCount, uploadedCount, percent };

      current.failedCount   = failedCount;
      current.totalCount    = totalCount;
      current.uploadedCount = uploadedCount;
      current.percent       = percent;

      return { ...prev, [rowData.engagementId]: updated };
    });
  };

  /* istanbul ignore next */
  const handleDelete = async (id) => {
    setProcessingMsg(false);
    setFailedDeleteLoading(true);

    const transactionID = failedUploads?.find((file) => file.id === id)?.transactionID || "";
    if (id === "all") {
      setFailedDeleteLoading(true);
      const filesBeingDeleted = failedUploads.filter((file) => selectedFiles.includes(file.id));
      filesBeingDeleted.forEach(rememberDeletedFile);
      const promises = selectedFiles.map(async (transId) => {
        const batchStatus = failedUploads?.find((file) => file.id === transId)?.batchStatus || "";
        const transactionID = failedUploads?.find((file) => file.id === transId)?.transactionID || "";
        const formData = {
          transactionID: batchStatus === "Processing" ? transactionID : transId,
          isReUpload: true,
          ErrorIds: batchStatus === "Processing" ? [transId] : [],
          EmailAddress: getAccount()?.username,
          EngagementIdGUID: rowData?.engagementId_GUID || null,
          deleteLog: true
        }

        await DeleteReUploadErrorLog(formData);
      });
      await Promise.all(promises);
      const processingFailCountAll = filesBeingDeleted.filter(f => !!f.controlId).length;
      decrementFailedCount(filesBeingDeleted.length, processingFailCountAll);
      setFailedDeleteLoading(false);
      setFailedUploads((prev) =>
        prev.filter((file) => !selectedFiles.includes(file.id))
      );
      setSelectedFiles([]);
    } else {
      const fileBeingDeleted = failedUploads?.find((file) => file.id === id);
      rememberDeletedFile(fileBeingDeleted);
      const batchStatus = fileBeingDeleted?.batchStatus || "";
      const formData = {
        transactionID: batchStatus === "Processing" ? transactionID : id,
        isReUpload: true,
        ErrorIds: batchStatus === "Processing" ? [id] : [],
        EmailAddress: getAccount()?.username,
        EngagementIdGUID: rowData?.engagementId_GUID || null,
        deleteLog: true
      }
      await DeleteReUploadErrorLog(formData).then(() => {
        setFailedDeleteLoading(false);
      });
      const isProcessingFail = !!fileBeingDeleted?.controlId;
      decrementFailedCount(1, isProcessingFail ? 1 : 0);
      setFailedUploads((prev) => prev.filter((file) => file.id !== id));
      setSelectedFiles((prev) => prev.filter((fileId) => fileId !== id));

    }
  };



  useEffect(() => {

    if (rowData?.area === AMERICAS) {
      setBaseURL(process.env.REACT_APP_API_URL_US)
    } else if (rowData?.area === EMEIA) {
      setBaseURL(process.env.REACT_APP_API_URL_EU)
    } else if (rowData?.area === APAC) {
      setBaseURL(process.env.REACT_APP_API_URL_AU)
    }

  }, [rowData?.area])

  useEffect(() => {
    setIsLoading(true); // Set loading state to true

    const cachedData = sessionStorage.getItem("userDataCache"); // Check session storage for cached data

    if (cachedData) {
      // If data exists in session storage, use it
      setUserData(JSON.parse(cachedData)); // Parse the JSON string to an object
      setIsLoading(false); // Set loading state to false
    } else {
      // If no cached data, make the API call

      setUserData(getApplicationDetail?.data); // Set user data with the fetched data

      // Store fetched data in session storage for future use
      sessionStorage.setItem(
        "userDataCache", // Key for user data in session storage
        JSON.stringify(getApplicationDetail?.data) // Convert the data to a JSON string
      );
      setIsLoading(false); // Set loading state to false

      if (getApplicationDetail?.status === ApiStatus.ERROR) {
        navigate("/"); // Redirect if unauthorized
        setIsLoading(false); // Set loading state to false even if there is an error
      }
    }
  }, [getApplicationDetail?.status, navigate]);

  const getSameFiles = (array1, array2, key) => {
    return array1.filter(item1 => array2.some(item2 => item1[key] === item2[key]));
  }
  useEffect(() => {
    const count = countEffectiveFiles(files, extractedFiles);
    setFileCount(count);
  }, [files, extractedFiles]);



  useEffect(() => {
    dispatch(getPartnerFilesBlocklistData());
  }, [dispatch]);
  useEffect(() => {
    if (partnerFilesBlocklistData?.status === ApiStatus.SUCCESS) {
      setBlockedFileList(partnerFilesBlocklistData?.data);
      setIsLoading(false);
    } else if (partnerFilesBlocklistData?.status === ApiStatus.ERROR) {
      setIsLoading(false);
      logger.error("An error occurred:", partnerFilesBlocklistData?.error);
    }
  }, [partnerFilesBlocklistData?.status]);

  const onFilterTextBoxChanged = (event) => {

    setSearchValue(event);
  };

  /* istanbul ignore next */
  const SaveErrorLog = async (payload) => {
    try {
      dispatch(partnersErrorSaveDataRequest(payload));
      // const response = await apiQueryWithToken.post(
      //   `api/errors/save`, //${baseURL}/
      //   payload
      // );
      // const responseData = response.data;
      // return responseData;
    } catch (error) {
      logger.error("Error fetching utility data:", error);
      // throw Error(error)
      //setAlertMessage("Something went wrong. Please try again.");
      // setPageReload(true);
      // setOpenDialog(true);
    }
  }


/* istanbul ignore next */
  const GetErrorsByEngagement = async (engagementId_GUID) => {
    try {
      const response = await apiQueryWithToken.post(
        `api/errors/engagement?engagementIdGUID=${engagementId_GUID}`
      );

      const responseData = response.data || [];

    } catch (error) {
      logger.error("Error fetching engagement errors:", error);
    }
  };

/* istanbul ignore next */
  const DeleteReUploadErrorLog = async (payload) => {
    try {

      const response = await apiQueryWithToken.delete(`api/errors/delete`, {
        headers: {
          "Content-Type": "application/json",
        },
        data: payload,
      });

      // GetErrorsByEngagement(engagementId_GUID);
      const responseData = response.data;
      return response.data;

    } catch (error) {
      logger.error("Error while deleting error log data", error);
      // throw Error(error)

    }
  }

  const removeCommonFiles = (array1, array2, key) => {
    return [
      ...array1.filter(obj1 => !array2.some(obj2 => obj1[key] === obj2[key]))
    ];
  }

/* istanbul ignore next */
  const validateFiles = async (files, extractedFilePath = "") => {
    const formData = new FormData();
    setIsLoading(true);
    const filePathMap = {};
    // Append files to FormData
    files.forEach(file => {
      formData.append("Files", file);
      filePathMap[file.name] = file.path ? file.path : extractedFilePath;

    });

    try {
      // Make the API call
      if (baseURL === process.env.REACT_APP_API_URL_US) {
        dispatch(getPartnersFileValidationUS(formData))
      } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
        dispatch(getPartnersFileValidationEU(formData))
      } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
        dispatch(getPartnersFileValidationAU(formData))
      }
      //const response = await apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/FileValidation`, formData);
    } catch (error) {
      logger.error("Error during file validation:", error);
    }
  };

  /* istanbul ignore next */
  useEffect(() => {
    if (partnersFileValidationData?.data && partnersFileValidationData?.status === ApiStatus.SUCCESS) {
      setIsLoading(false);
      if (!Array.isArray(partnersFileValidationData?.data)) {
        // throw new Error("Expected an array of files, but did not receive one.");
      }
      const filePathMap = files.reduce((acc, file) => {
        acc[file.name] = file.path || file.name; // Map file names to their paths
        return acc;
      }, {});
      const newProtectionStatusMap = partnersFileValidationData?.data.reduce((acc, item) => {

        const fullPath = filePathMap[item.fileName];
        acc[fullPath] = item.isFileProtected; // to handle nested files
        return acc;
      }, {});
      /* istanbul ignore next */
      (async () => {
        await new Promise(resolve => {
          setFileProtectionStatus(prevStatus => {
            const updatedStatus = { ...prevStatus, ...newProtectionStatusMap };
            resolve(updatedStatus); // Resolve with updated state
            return updatedStatus;
          });
        });

        // Update folder protection based on nested files
        updateFolderProtection(newProtectionStatusMap);
        partnersFileValidationData?.data?.forEach(item => {
          const fullPath = filePathMap[item.fileName];
          if (item.isFileProtected) {
            setIsCorrectPasswords(prevPasswords => ({
              ...prevPasswords,
              [fullPath]: false, // Set to false if the file is protected
            }));
          } else {
            setIsCorrectPasswords(prevPasswords => ({
              ...prevPasswords,
              [fullPath]: true, // Set to true if the file is not protected
            }));
          }
          setshowErrorMessage(prevPasswords => ({
            ...prevPasswords,
            [fullPath]: false, // Set to false if the file is not protected
          }));
        });
        setIsLoading(false);
      })();
    }
  }, [partnersFileValidationData?.status]);
  /* istanbul ignore next */
  const updateFolderProtection = (fileProtectionStatus) => {
    setFileStructure(prevFileStructure => {
      const updatedFileStructure = { ...prevFileStructure };

      Object.keys(fileProtectionStatus).forEach(filename => {
        if (fileProtectionStatus[filename]) { // If file is protected
          const pathParts = filename.split("/").filter(Boolean); // Remove empty parts
          let currentFolder = updatedFileStructure;

          for (let i = 0; i < pathParts.length - 1; i++) {
            const folderName = pathParts[i];

            // Ensure the folder exists before modifying it
            if (currentFolder[folderName]) {
              currentFolder[folderName].isLocked = true;
              currentFolder = currentFolder[folderName]; // Move deeper in the structure
            } else {
              break; // Stop if folder does not exist
            }
          }
        }
      });

      return updatedFileStructure;
    });
  };

  /* istanbul ignore next */
  const onRemoveProtectedFile = (fileName, password) => {
    // Update the state to remove the file from the protected list
    setProtectedFiles(protectedFiles.filter(file => file.name !== fileName));
  };

  /* istanbul ignore next */
  const handleSkipAndContinueClick = async () => {

    setIsSkipContinueClicked(true);
    setProtectedFiles([]);
    goBack(-1);
  }

  /* istanbul ignore next */
  const initiateProcess = async (controlIds, isReprocess) => {

    const formJSONData = {
      controlIds: controlIds,
      userEmailID: getAccount()?.username,
      Region: rowData?.area,
      BlobFileName: " ",
      TransactionID: " ",
      eng_password: pwdSkipped.current ? '' : engLevelPwd,
      isReprocess: isReprocess
    }

    try {
      if (baseURL === process.env.REACT_APP_API_URL_US) {
        dispatch(partnersUploadProcessingUS(formJSONData));
      } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
        dispatch(partnersUploadProcessingEU(formJSONData));
      } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
        dispatch(partnersUploadProcessingAU(formJSONData));
      }
      // Assuming the response is the array itself or the array is wrapped in a data property

    } catch (error) {
      logger.error("Error during file validation:", error);
    }
    finally {
      setIsLoading(false);

    }
  };
  useEffect(() => {
    if (partnersUploadProcessingData?.status === ApiStatus.SUCCESS) {
      setProcessingResult(true);
      const process = initiateAutoProcess.current.find(
        (p) => p.engID === rowData.engagementId
      );
      if (process) {
        process.hasInitiated = true;
      }
    }
  }, [partnersUploadProcessingData?.status])

  /* istanbul ignore next */
  const initiateReProcess = async (controlIds) => {
    // Backend expects controlIds as an array of strings, e.g. ["180804", "180805"].
    const normalizedControlIds = (controlIds || [])
      .filter((id) => id !== null && id !== undefined && id !== "")
      .map((id) => String(id));
    const formJSONData = {
      controlIds: normalizedControlIds,
      userEmailID: getAccount()?.username,
      Region: rowData?.area,
      BlobFileName: " ",
      TransactionID: " ",
      eng_password: pwdSkipped.current ? '' : engLevelPwd,
      isReprocess: true
    }

    try {
      if (baseURL === process.env.REACT_APP_API_URL_US) {
        dispatch(partnersUploadReProcessingUS(formJSONData));
      } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
        dispatch(partnersUploadReProcessingEU(formJSONData));
      } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
        dispatch(partnersUploadReProcessingAU(formJSONData));
      }
      // Assuming the response is the array itself or the array is wrapped in a data property

    } catch (error) {
      logger.error("Error during file validation:", error);
    }
    finally {
      // setIsLoading(false);

    }
  };

  useEffect(() => {
    if (partnersUploadReProcessingData?.status === ApiStatus.SUCCESS) {
      const data = partnersUploadReProcessingData?.data || [];
      const processedControlIDS = data
        .filter(item => item.processStatus == "Completed")
        .map(item => item.controlId);
      const failedControlIDS = data
        .filter(item => item.processStatus != "Completed")
        .map(item => item.controlId);

      const remainingAfterProcess = failedUploads.filter(
        (file) => !processedControlIDS.includes(file.controlId)
      ).length;
      if (processedControlIDS.length > 0 && remainingAfterProcess === 0) {
        setProcessingMsg(true);
      }

      const formData = {
        transactionID: failedUploads.find(item => item.controlId === processedControlIDS[0])?.transactionID
          || processedControlIDS[0]
          || failedUploads[0]?.transactionID
          || "", isReUpload: true,
        ErrorIds: failedUploads.filter(item => processedControlIDS.includes(item.controlId)).map(item => item.errorId || item.id) || [],
        EmailAddress: getAccount()?.username,
        EngagementIdGUID: rowData?.engagementId_GUID || null,
        deleteLog: true
      }
      /* istanbul ignore next */
      if (formData?.ErrorIds?.length > 0) {
        DeleteReUploadErrorLog(formData);
      }

      setDisableContinue(false);

      if (processedControlIDS.length > 0) {
        // Type 1 (blob-failure) re-uploads already had uploaded+1 / failed-1
        // applied by generateMetadata's updateUploadedCount. Type 2 (processing-
        // failure) re-uploads went straight to reprocess and were not counted yet.
        // Only adjust counts for Type 2 here so failedCount is not decremented twice.
        const type2Processed = processedControlIDS.filter(
          (cid) => !retryMetadataControlIds.current.has(cid)
        );
        initialFailedCountRef.current = Math.max(0, initialFailedCountRef.current - type2Processed.length);
        processedControlIDS.forEach((cid) => retryMetadataControlIds.current.delete(cid));
        // Type 2 files already counted their blob upload in uploadedCount during
        // the initial upload, so only failedCount needs to come down here.
        setUploadPercentage((prev) => {
          const current = prev[rowData.engagementId] || {};
          const failedCount = Math.max(0, (current.failedCount || 0) - type2Processed.length);
          return {
            ...prev,
            [rowData.engagementId]: { ...current, failedCount },
          };
        });
        // Map processed controlIds to their failedUploads ids so we can drop them
        // from selectedFiles (selectedFiles holds ids, not controlIds).
        const processedIds = failedUploads
          .filter(item => processedControlIDS.includes(item.controlId))
          .map(item => item.id);
        setFailedUploads(prev =>
          prev.filter(item => !processedControlIDS.includes(item.controlId))
        );
        setSelectedFiles(prev =>
          prev.filter(fileId => !processedIds.includes(fileId))
        );
      }

      if (failedControlIDS.length > 0) {
        setFailedUploads(prev =>
          prev.map(item =>
            failedControlIDS.includes(item.controlId)
              ? { ...item, attempts: (item.attempts || 0) + 1 }
              : item
          )
        );
      }

      setUploadingFileId(null);
      setUploadingFileIds([]);
    } else if (partnersUploadReProcessingData?.status === ApiStatus.ERROR) {
      setDisableContinue(false);
      setUploadingFileId(null);
      setUploadingFileIds([]);
    }

  }, [partnersUploadReProcessingData]);
  /* istanbul ignore next */
  const ValidateContentFile = async (file, transactionID, updateUploadedCount, blobURL, isZip, isRetry) => {

    const gicsSelection = resolveGicsSelection(userData?.gicsSectorMappings, rowData);
    const ccsValues = rowData.ccs;
    // Create a mapping of CCS names to their IDs
    const ccsMap = {};
    userData?.ccs?.forEach(item => {
      ccsMap[item.ccsType] = item.ccsId;
    });
    // Split the CCS values and map them to their corresponding IDs
    const ccsIds = ccsValues.split(', ').map(ccsName => ccsMap[ccsName.trim()]).filter(id => id !== undefined);
    // Join the IDs into a comma-separated string
    const ccsIdsString = ccsIds.join(', ');
    let region = '';
    if (rowData?.country === UNITED_KINGDOM) {
      region = 'EMEIA';
    } else {
      region = rowData?.area;
    }

    const formData = new FormData();
    formData.append("ModifiedBy", "Test");
    formData.append("Region", rowData?.area);
    formData.append("EngagementId", rowData.engagementId);
    formData.append("UserID", 12);
    appendGicsUploadFields(formData, gicsSelection);
    formData.append("UserEmailID", getAccount()?.username);
    formData.append("CCS", ccsIdsString);
    formData.append("Country", rowData.country);
    formData.append("projectName", rowData.engagementName);
    formData.append("clientName", rowData.clientName);
    formData.append("Function", "Default");
    formData.append("Config_file", "config");
    formData.append("Revenue", rowData.revenueRange);
    formData.append("SSLCompetancy", rowData.ssl);
    formData.append("CreatedBy", getAccount()?.name);
    formData.append("NewRegion", rowData?.region);
    formData.append("Area", rowData.area);
    formData.append('TransactionID', transactionID);
    formData.append("Exsists", true);
    formData.append("EngagementId_GUID", rowData?.engagementId_GUID);
    formData.append("TargetArea", rowData?.targetArea);
    formData.append("TargetCountry", rowData?.targetCountry);
    formData.append("TargetRegion", rowData?.targetRegion);
    formData.append("sortCodes", rowData?.sortCodes);
    formData.append("FreeTextTags", rowData?.freeTextTags);
    formData.append("ContentType", getMimeType(file.name));
    formData.append("IsEyOwnFolder", true);
    formData.append("IsClientDataFolder", isClientEngagement);
    formData.append("IsCorrectPasword", false);
    formData.append("BlobFileName", blobURL);
    formData.append("isZip", isZip)
    formData.append("Path", file.path.replace(/^\/+/, ""));
    formData.append("Filename", file.name);
    formData.append("FileModifiedDate", new Date(file.lastModified).toISOString());
    formData.append("FileSize", (file.size / (1024 * 1024)).toFixed(2)); // size in MB, rounded to 2 decimals
    try {
      // Make the API call
      let validateContentFileEndpoint;

      if ((file.name === "testdemofile.pptx") || ((file.name === "testdemofile2.pptx" || file.name === "testdemofile3.pptx") && !isRetry)) {
        validateContentFileEndpoint = "/api/partners/ValidateContentFile0"
      }
      else {
        validateContentFileEndpoint = "/api/partners/ValidateContentFile";
      }

      const response = await apiQueryToUploadDataRegional.post(`${baseURL}${validateContentFileEndpoint}`, formData)
        .then((data) => {
          updateUploadedCount(1, 0);
          return data;
        })
        .catch((error) => {


          if (!isRetry) {
            updateUploadedCount(0, 1);
            const UniqueID = generateGUID();
            setFailedUploads(prev => [
              ...prev,
              {
                file: file,
                fileName: file.name,
                reason: error.name,
                message: error.message,
                errorCode: String(error.response?.status || ""),
                engagementID: rowData.engagementId,
                // engagementId_GUID: rowData?.engagementId_GUID,
                region: rowData.region,
                id: UniqueID,
                attempts: 0,
                currentFlow: true
              }
            ]);
            const formData = {
              uploadType: isZip ? "zip" : file.name ? "file" : "folder",
              uploadFileName: file.name,
              uploadedBy: getAccount().username,
              region: rowData.area,
              reasonPhrase: error.name,
              errorMessage: error.message,
              errorCode: String(error.response?.status),
              url: error.config?.url,
              additionalInfo: file.path ? file.path : file.name,
              engagementIdGUID: rowData?.engagementId_GUID || null,
              UploadId_GUID: UPLOADID_GUID,
            }
            const response = SaveErrorLog(formData);
          }
          // throw new Error(error);
          logger.info("Error log saved successfully:", response);
        });;


      // Assuming the response is the array itself or the array is wrapped in a data property
      const filesArray = response.data || response;


      // Check if filesArray is indeed an array
      if (!Array.isArray(filesArray)) {
        // throw new Error("Expected an array of files, but did not receive one.");
      }
      else {
        const unprotectedItems = filesArray.filter(item => item.isFileProtected);

        if (unprotectedItems.length > 0) {
          const mappedItems = unprotectedItems.map(item => ({
            fileName: item.filePath.split('/').pop(),
            filePath: item.filePath,
            controlId: item.controlid,  // make sure this field exists in each item
            uploadedBy: getAccount()?.username,
            dateCreated: new Date().toISOString().replace('Z', '').slice(0, 23),
          }));

          setAllProtectedFiles(prev => [...prev, ...mappedItems]);
        }
        return unprotectedItems;

      }
    } catch (error) {
      logger.error("Error during file validation:", error);
    }
    finally {
      setIsLoading(false);

    }
  };

  /* istanbul ignore next */
  const handleSPUpload = (updateUploadedCount,dedupedSpFilesUploaded, nonSpCount = 0) => {
    const spFiles = dedupedSpFilesUploaded?.filter(f => f.isSPFile);
    // Deduplicate SP files by name, keeping the latest by lastModified
    const dedupedSpFiles = Object.values(
      (spFiles || []).reduce((acc, file) => {
        const existing = acc[file.name];
        if (!existing || (file.lastModified || 0) > (existing.lastModified || 0)) {
          acc[file.name] = file;
        }
        return acc;
      }, {})
    );
    // Calculate aggregate file size (in bytes) for all SharePoint files
    const total_agg_filesize = dedupedSpFiles.reduce((sum, file) => sum + (Number(file.size) || 0), 0);
    const newFilesPayload = dedupedSpFiles.map(file => ({
      name: file.name,
      size: String(file.size),
      id: file.id,
      path: file.path,
      FileModifiedDate: new Date(file.lastModified).toISOString(),
    }));
    const isZip = dedupedSpFiles.map(f => f.name).some(name => /\.zip(\?|$)/i.test(name));
    setShowProgressPage(true);
    let regionX = '';
    if (rowData?.country === "United Kingdom") {
      regionX = 'EMEIA'
    } else {
      regionX = rowData?.area
    }
    const gicsSelection = resolveGicsSelection(userData?.gicsSectorMappings, rowData);
    const ccsValues = rowData?.ccs;
    // Create a mapping of CCS names to their IDs
    const ccsMap = {};
    userData?.ccs?.forEach(item => {
      ccsMap[item.ccsType] = item.ccsId;
    });
    // Split the CCS values and map them to their corresponding IDs
    const ccsIds = ccsValues.split(', ').map(ccsName => ccsMap[ccsName.trim()]).filter(id => id !== undefined);
    // Join the IDs into a comma-separated string
    const ccsIdsString = ccsIds.join(', ');

    const formJSONData = {
      total_agg_filesize: String(total_agg_filesize),
      Area: rowData?.area,
      CCS: ccsIdsString,
      Config_file: "config",
      Country: rowData?.country,
      CreatedBy: getAccount()?.name,
      EngagementId: rowData?.engagementId,
      EngagementId_GUID: rowData?.engagementId_GUID,
      Exsists: true,
      Function: "Default",
      IsClientDataFolder: isClientEngagement,
      IsCorrectPasword: false,
      IsEyOwnFolder: true,
      ModifiedBy: "Test",
      NewRegion: rowData?.region,
      Region: regionX,
      Revenue: rowData?.revenueRange,
      SSLCompetancy: rowData?.ssl,
      ...toGicsUploadPayload(gicsSelection),
      TransactionID: UPLOADID_GUID,
      UserEmailID: getAccount()?.username,
      UserID: 12,
      clientName: rowData?.clientName,
      isZip: isZip,
      projectName: rowData?.engagementName,
      sortCodes: "",
      TargetArea: rowData?.targetArea,
      TargetCountry: rowData?.targetCountry,
      TargetRegion: rowData?.targetRegion,
      P_SharePointSite_ID: SPSSiteData?.id,
      P_SharePoint_FileList: newFilesPayload,
      P_UserAccessToken: SPToken,
      eng_password: pwdSkipped.current ? '' : engLevelPwd,
      FreeTextTags: rowData?.freeTextTags,
      // Use combined count when drag-and-drop and SharePoint both present
      totalFileUploaded: dedupedSpFiles.length + (nonSpCount || 0),
      IsOverrideFile: overrideFiles.current === true ? true : false
    }
    apiQueryToUploadDataRegional
      .post(
        `${baseURL}/api/partners/UploadSharePointFilesToBlob`,
        formJSONData
      )
      .then((response) => {
        // Reflect deduped count in progress circle
        updateUploadedCount(dedupedSpFiles.length, 0);
        //  setShowProcessingPage(false);
      })
      .catch((error) => {
        updateUploadedCount(0, dedupedSpFiles.length);
        if (error.response && error.response.status === 500) {
          if (error.response.data.statusCode && error.response.data.statusCode === 406) {
          }
        } else {
          setIsUploadDisabled(false);

        }
        setAlertMessage("Something went wrong. Please try again.");
        setPageReload(true);
        setOpenAlertDialog(true);

      }
      );

  }

  /* istanbul ignore next */
  const getSasToken = async (userEmailID) => {
    try {
      const response = await apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/SasToken`, {
        userEmailID
      });

      return response.data;
    } catch (error) {
      logger.error("Error fetching SAS token:", error);
    }
  }

  /* istanbul ignore next */
  const ValidateUploadedFileStatus = async (controlIds) => {

    const formJSONData = {
      controlIds: controlIds,
      userEmailID: getAccount()?.username,
      Region: rowData?.area,
      BlobFileName: " ",
      TransactionID: UPLOADID_GUID
    }
    try {
      // Make the API call

if(baseURL === process.env.REACT_APP_API_URL_US){
  dispatch(partnersUploadedFileStatusRequestUS(formJSONData))
} else if(baseURL === process.env.REACT_APP_API_URL_EU){
  dispatch(partnersUploadedFileStatusRequestEU(formJSONData))
} else if(baseURL === process.env.REACT_APP_API_URL_AU){
  dispatch(partnersUploadedFileStatusRequestAU(formJSONData))
}
    } catch (error) {
      logger.error("Error during file validation:", error);
    }
    finally {
      setIsLoading(false);

    }
  };

  useEffect(() => {
    if(partnersUploadedFileStatusData?.status === ApiStatus.SUCCESS){
      setShowProcessingPage(false);
      // Assuming the response is the array itself or the array is wrapped in a data property
      const filesArray = partnersUploadedFileStatusData?.data;


      // Check if filesArray is indeed an array
      if (!Array.isArray(filesArray)) {
        // throw new Error("Expected an array of files, but did not receive one.");
      }
      else {
        const unprotectedItems = filesArray.filter(item => item.isFileProtected && item.filePath != "");

        if (unprotectedItems.length > 0) {
          const mappedItems = unprotectedItems.map(item => ({
            fileName: item.filePath.split('/').pop(),
            filePath: item.filePath,
            controlId: item.controlid,
            uploadedBy: getAccount()?.username,
            dateCreated: new Date().toISOString().replace('Z', '').slice(0, 23), 
          }));

          // setAllProtectedFiles(prev => [...prev, ...mappedItems]);
          setAllProtectedFiles(mappedItems);
        }
        else{
          setAllProtectedFiles([]);
        }
      //    return unprotectedItems;

      }
    } else if(partnersUploadedFileStatusData?.status === ApiStatus.ERROR){
      setShowProcessingPage(false);
    }
  }, [partnersUploadedFileStatusData])
  const [fileStatus, setFileStatus] = useState([]);
  const fileStatusRef = useRef([]);

  /* istanbul ignore next */
  const fetchFileStatus = async (controlIds, isSPFileUpload) => {
    try {
      let payload = {};
      //if (!isSPFileUpload) {
      payload = {
        userEmailId: getAccount()?.username,
        UploadGuid: UPLOADID_GUID,
        isEngagementAdmin: userProfileDetails?.isEngagementAdmin === null ? '' : userProfileDetails?.isEngagementAdmin
        //...(controlIds && { controlIds }) // Only send if provided

      };
      // } else {
      //   payload = { userEmailId: getAccount()?.username }
      // }
      const { data } = await apiQueryWithToken.post(
        'api/partners/GetFileProcessedCount',
        payload
      );


      setFileStatus(data);

      if (
        data &&
        data[0].engagementGuid === rowData.engagementId_GUID && data[0].totalFileUploaded > 0
      ) {
        setTotalFileProcessed(data[0].totalFileProcessed);
        setTotalFileUploaded(data[0].totalFileUploaded);
        setTotalFileFailed(data[0]?.totalFileFailed);
        fileStatusRef.current = data;
        return data;
      }
    } catch (error) {
      logger.error("An error occurred:", error);
      return [];
    }
  };

  /* istanbul ignore next */
  const generateMetadata = async (file, formData, updateUploadedCount, isRetry, transactionID) => {
    try {
      const response = await apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/GenerateMetadata`, formData);
      updateUploadedCount(1, 0);

      if (!isRetry) {
        // Only update uploadedControlIDs on initial upload so the useEffect
        // does not fire initiateProcess again during a retry flow.
        SetUploadedControlIDs(prev => [...prev, response.data.controlid]);

        const process = initiateAutoProcess.current.find(
          (p) => p.engID === rowData.engagementId
        );

        if (process) {
          process.uploadID.push(response.data.controlid);

        }
      }
      if (isRetry) {
   
          retryState.current.completed++;
  
        const deleteformData = {
          transactionID: formData.get("TransactionID"),
          isReUpload: true,
          ErrorIds: [],
          EmailAddress: getAccount()?.username,
          EngagementIdGUID: rowData?.engagementId_GUID || null,
        }
        DeleteReUploadErrorLog(deleteformData);
        /*code added*/
        // const updated = failedUploads.filter((file) => file.id !==  formData.TransactionID);
        setFailedUploads((prev) => prev.filter((file) => file.id !== formData.get("TransactionID"),))
        //  setFailedUploads(updated);
        setSelectedFiles((prev) => prev.filter((fileId) => fileId !== formData.get("TransactionID"),));
        setShowProcessingPage(false);
        setDisableContinue(false);

        // Trigger reprocessing for the reuploaded file using its own returned controlid.
        if (response?.data?.controlid) {
          // updateUploadedCount above already applied uploaded+1 / failed-1 for
          // this blob-failure file; mark it so the reprocess handler skips it.
          retryMetadataControlIds.current.add(response.data.controlid);
          if (bulkReprocessMode.current) {
            // Collect for a single combined reprocess call in handleReuploadAll.
            bulkReprocessControlIds.current.push(response.data.controlid);
          } else {
            await initiateReProcess([response.data.controlid]);
          }
        }

      }
      return response.data;
    } catch (error) {
      if (!isRetry) {
        setFailedUploads(prev => [
          ...prev,
          {
            file: file,
            fileName: file.name,
            reason: error.name,
            message: error.message,
            errorCode: error.code || "",
            engagementID: rowData.engagementId,
            // engagementId_GUID: rowData?.engagementId_GUID,
            region: rowData.region,
            id: transactionID, //UniqueID
            attempts: 0,
            currentFlow: true,
            lastModifiedDate: new Date(file.lastModified).toISOString(),
            createdDate: new Date().toISOString().replace('Z', '').slice(0, 23),
            uploadedBy: getAccount().username,
          }
        ]);
      }
      const ext = file.path.split('.').pop();
      const formData = {
        uploadType: ext,
        uploadFileName: file.name,
        uploadedBy: getAccount().username,
        region: rowData.area,
        reasonPhrase: error.message,
        errorMessage: error.code,
        errorCode: error.code,
        url: error.url || " ",
        additionalInfo: file.path ? file.path : file.name,
        engagementIdGUID: rowData?.engagementId_GUID || null,
        transactionID: transactionID, //UniqueID
        UploadId_GUID: UPLOADID_GUID,
      }
      if (!isRetry) {
        updateUploadedCount(0, 1);
        const response = SaveErrorLog(formData);
      }

      if (isRetry) {
        setShowProcessingPage(false);
        setDisableContinue(false);
        setFailedUploads((prev) =>
          prev.map((file) =>
            file.id === transactionID ? { ...file, attempts: file.attempts + 1 } : file
          )
        );
      }
      // throw new Error(error);


    }
    finally {
      setUploadingFileId(null);
    }
  }

  const [isUploadPaused, setIsUploadPaused] = useState(false);
  const [isUploadAutoPaused, setIsUploadAutoPaused] = useState(false);

  useEffect(() => {
    const progress = uploadPercentage[rowData.engagementId] || {};
    const engagementStatus = engagementPauseStatus.current[rowData.engagementId];
    if (engagementStatus) {
      engagementStatus.uploadCount = progress?.uploadedCount || 0;
    }
  }, [isUploadPaused, isUploadAutoPaused]);

  const syncPauseStatusToGrid = () => {
    setUploadPercentage(prev => {
      const current = prev[rowData.engagementId];
      if (!current) return prev;
      return {
        ...prev,
        [rowData.engagementId]: { ...current },
      };
    });
  };

  // -------------------- Manual Pause/Resume Handler --------------------
  /* istanbul ignore next */
  const handleUploadProgress = (engagementId) => {
    // Get all active upload sessions for this engagement
    const engagementSessions = engagementPauseStatus.current[engagementId] || {};
    const sessionKeys = Object.keys(engagementSessions).filter(key => 
      key.startsWith(`${engagementId}_`) // Only get upload session keys
    );

    // Determine current pause state by checking if ANY session is paused (manual OR auto)
    const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused || false;
    const isEnagementAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused || false;
    const anySessionPaused = isEnagementPaused || isEnagementAutoPaused;

    // Toggle: if ANY session is paused (manual or auto), resume ALL; otherwise pause ALL
    const willPause = !anySessionPaused;

    if (willPause && sessionKeys.length > 0) {
      // === Manual PAUSE ALL SESSIONS ===
      setAlertMessage(
        `The upload has been paused for Engagement ${engagementId} and can be resumed in the same session.`
      );
      setOpenAlertDialog(true);

      sessionKeys.forEach(sessionId => {
        const prev = engagementSessions[sessionId] || {};
        
        // Only pause if not already auto-paused (preserve auto-pause state)
        if (!prev.isUploadAutoPaused) {
          // Abort current batch if AbortController exists
          try {
            prev.abortController?.abort?.();
          } catch { /* noop */ }

          engagementPauseStatus.current[engagementId][sessionId] = {
            ...prev,
            isUploadPaused: true,            
          };
        }
      });

      const progress = uploadPercentage[rowData.engagementId] || {};
      engagementPauseStatus.current[engagementId].isUploadPaused = true;
      engagementPauseStatus.current[engagementId].uploadCount = progress.uploadedCount || 0;

      setIsUploadPaused(true);
      syncPauseStatusToGrid();
    } else if (navigator.onLine) {
      // === Manual RESUME ALL SESSIONS (including auto-paused) ===
      sessionKeys.forEach(sessionId => {
        const prev = engagementSessions[sessionId] || {};

        // Create fresh AbortController for resumed upload
        const freshAbortController = new AbortController();

        engagementPauseStatus.current[engagementId][sessionId] = {
          ...prev,
          isUploadPaused: false,
          isUploadAutoPaused: false, // Clear auto-pause as well
          offlineAlertShown: false, // Reset offline alert flag
          abortController: freshAbortController,
          // Mark that user manually resumed (optional flag for tracking)
          pendingManualResume: true,
        };

        // Wake the upload loop if it's waiting
        const resolver = prev.resumeResolve;
        if (typeof resolver === "function") {
          try {
            resolver();
          } catch { /* noop */ }
          engagementPauseStatus.current[engagementId][sessionId].resumeResolve = null;
        }
      });

      engagementPauseStatus.current[engagementId].isUploadPaused = false;
      engagementPauseStatus.current[engagementId].isUploadAutoPaused = false;

      setIsUploadPaused(false);
      setIsUploadAutoPaused(false); // Clear both pause states
      syncPauseStatusToGrid();
    }
  };

  /* istanbul ignore next */
  const TokenManager = (() => {
    let isRefreshing = false;
    let refreshPromise = null;
    let currentToken = null;
    let currentSasData = null;

    const getToken = () => currentToken;
    const getSasData = () => currentSasData;

    const refreshToken = async () => {
      if (!isRefreshing) {
        isRefreshing = true;
        refreshPromise = getSasToken(getAccount()?.username)
          .then(newSasData => {
            currentToken = newSasData.result.token;
            currentSasData = newSasData;
            return newSasData;
          })
          .catch(err => {
            logger.error("Token refresh failed:", err);
            throw err;
          })
          .finally(() => {
            isRefreshing = false;
          });
      }
      return refreshPromise;
    };

    return {
      getToken,
      getSasData,
      refreshToken
    };
  })();

  // -------------------- Config & Helpers --------------------
  const BLOCK_SIZE = 16 * 1024 * 1024; // 16MB
  const CONCURRENCY = 4;
  const MAX_RETRIES = 3;

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const backoffDelay = (attempt) => 300 * Math.pow(2, attempt) + Math.random() * 100;

  // Sentinel error to signal "pause this batch, don't fail the upload"
  /* istanbul ignore next */
  class PauseError extends Error {
    constructor(message = "PAUSE_OFFLINE_OR_ABORT") {
      super(message);
      this.name = "PauseError";
      this.isPause = true;
    }
  }

  // -------------------- Upload Function --------------------
  /* istanbul ignore next */
  const uploadFile = async (
    file,
    sasData,
    updateUploadedCount,
    isRetry,
    blobURL,
    transactionID,
    formData
  ) => {
    const uploadSessionId = `${rowData.engagementId}_${transactionID}_${Date.now()}`;
    let cleanupListeners = null;
    let heartbeatIntervalId = null;

    try {
      if (!file) return;

      const engagementId = rowData.engagementId;
      let token = sasData.result.token;

      if (file.name === "testdemofile.pptx" ||
        ((file.name === "testdemofile2.pptx" || file.name === "testdemofile3.pptx") && !isRetry)) {
        token = "";
      }

      let blockBlobClient = new BlockBlobClient(`${sasData.result.url}/${blobURL}?${token}`);
      const totalBlocks = Math.ceil(file.size / BLOCK_SIZE);

      // Initialize session state FIRST
      if (!engagementPauseStatus.current[engagementId]) {
        engagementPauseStatus.current[engagementId] = {
          isUploadPaused: false,
          isUploadAutoPaused: false,
          uploadCount: 0,
        };
      }

      if (!engagementPauseStatus.current[engagementId][uploadSessionId]) {
        engagementPauseStatus.current[engagementId][uploadSessionId] = {
          abortController: new AbortController(),
          resumeResolve: null,
          handlers: null,
          resumeData: { nextBlock: 0, blockIds: [] },
          isUploadPaused: false,
          isUploadAutoPaused: false,
          offlineAlertShown: false,
          pendingManualResume: false,
        };
      }

      const pauseEntry = engagementPauseStatus.current[engagementId][uploadSessionId];
      const resumeData = pauseEntry.resumeData || {};

      const blockIds = Array.isArray(resumeData.blockIds) ? [...resumeData.blockIds] : [];
      const blockIdSet = new Set(blockIds);
      let nextBlock = Number.isFinite(resumeData.nextBlock) ? resumeData.nextBlock : 0;
      const stagedBlocks = new Set(resumeData.blockIds || []);

      const ensureFreshAbortController = () => {
        const status = engagementPauseStatus.current[engagementId][uploadSessionId];
        const ac = status.abortController;
        if (!ac || ac.signal?.aborted) {
          status.abortController = new AbortController();
        }
      };

      const getAbortController = () => {
        ensureFreshAbortController();
        return engagementPauseStatus.current[engagementId][uploadSessionId].abortController;
      };

      const waitForResume = async () =>
        new Promise((resolve) => {
          const status = engagementPauseStatus.current[engagementId][uploadSessionId];
          status.resumeResolve = resolve;

          const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
          const isEngagementAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused;

          const isPaused = Boolean(status?.isUploadPaused);
          const isAutoPaused = Boolean(status?.isUploadAutoPaused);
          const pendingManual = Boolean(status?.pendingManualResume);

          if (pendingManual || (!isPaused && !isAutoPaused && !isEnagementPaused && !isEngagementAutoPaused && navigator.onLine)) {
            if (pendingManual) {
              status.pendingManualResume = false;
            }
            status.resumeResolve = null;
            resolve();
          }
        });

      const resumeNow = () => {
        const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
        if (!status) return;

        status.isUploadAutoPaused = false;

        try {
          const newSasData = TokenManager.getSasData();
          const newToken = TokenManager.getToken();
          if (newSasData && newToken) {
            sasData = newSasData;
            token = newToken;
            blockBlobClient = new BlockBlobClient(`${sasData.result.url}/${blobURL}?${token}`);
          }
        } catch (err) {
          logger.error("Error refreshing token in resumeNow:", err);
        }

        ensureFreshAbortController();

        const resolver = status.resumeResolve;
        if (typeof resolver === "function") {
          status.resumeResolve = null;
          try {
            resolver();
          } catch (err) {
            logger.error("Error calling resolver:", err);
          }
        }
      };

      if (!pauseEntry.handlers) {
        const onOffline = () => {
          const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
          if (!status) return;

          const progress = uploadPercentage[engagementId] || {};
          engagementPauseStatus.current[engagementId].isUploadAutoPaused = true;
          engagementPauseStatus.current[engagementId].uploadCount = progress.uploadedCount || 0;
          
          setIsUploadAutoPaused(true);
          syncPauseStatusToGrid();

          const manualPaused = Boolean(status.isUploadPaused);
          const autoPaused = Boolean(status.isUploadAutoPaused);
          const willAutoPause = !manualPaused && !autoPaused;

          if (willAutoPause) {
            status.isUploadAutoPaused = true;
            status.resumeData = { nextBlock, blockIds };
            status.abortController?.abort?.();
          }

          const allEngagements = engagementPauseStatus.current;
          const hasShownOfflineAlert = Object.keys(allEngagements).some(engId => {
            const sessions = allEngagements[engId] || {};
            return Object.keys(sessions).some(key =>
              sessions[key]?.offlineAlertShown === true
            );
          });

          if (!hasShownOfflineAlert) {
            engagementPauseStatus.current[engagementId][uploadSessionId].offlineAlertShown = true;
            setAlertMessage?.(
              "You're offline, so your upload is paused. Please keep this session open – your upload will resume once you're back online."
            );
            setOpenAlertDialog?.(true);
          }
        };

        const onOnline = () => {
          const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
          if (!status) return;

          engagementPauseStatus.current[engagementId].isUploadAutoPaused = false;
          setIsUploadAutoPaused(false);
          engagementPauseStatus.current[engagementId][uploadSessionId].offlineAlertShown = false;
          syncPauseStatusToGrid();

          const autoPaused = Boolean(status.isUploadAutoPaused);
          if (autoPaused) {
            resumeNow();
          }
        };

        window.addEventListener("offline", onOffline);
        window.addEventListener("online", onOnline);

        pauseEntry.handlers = { onOffline, onOnline };

        cleanupListeners = () => {
          window.removeEventListener("offline", onOffline);
          window.removeEventListener("online", onOnline);
          const current = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
          if (current) {
            delete current.handlers;
            delete current.resumeResolve;
          }
        };
      }

      // Main upload loop - CHECK PAUSE STATE BEFORE EACH ITERATION
      while (nextBlock < totalBlocks) {
        // CHECK PAUSE STATE AT THE START OF EACH LOOP ITERATION
        const statusSnapshot = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
        if (!statusSnapshot) break;

        const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
        const isEngagementAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused;

        // Wait if paused
        if (isEnagementPaused || isEngagementAutoPaused || !navigator.onLine) {
          statusSnapshot.isUploadPaused = isEnagementPaused;
          statusSnapshot.isUploadAutoPaused = isEngagementAutoPaused || !navigator.onLine;
          statusSnapshot.resumeData = { nextBlock, blockIds };

          await waitForResume().catch(() => { });
          continue;
        }

        const batchAbort = getAbortController();
        const batchPromises = [];

        for (let i = 0; i < CONCURRENCY && nextBlock < totalBlocks; i++) {
          const start = nextBlock * BLOCK_SIZE;
          const end = Math.min(start + BLOCK_SIZE, file.size);
          const block = file.slice(start, end);
          const blockId = btoa(`block-${nextBlock.toString().padStart(6, "0")}`);
          const thisBlockIndex = nextBlock;

          nextBlock++;

          if (!blockIdSet.has(blockId)) {
            blockIdSet.add(blockId);
            blockIds.push(blockId);
          }

          const uploadChunk = async () => {
            if (stagedBlocks.has(blockId)) {
              return;
            }

            let attempt = 0;
            while (attempt < MAX_RETRIES) {
              // CHECK PAUSE STATE BEFORE EACH RETRY ATTEMPT
              const currentStatus = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
              const isEngPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
              const isEngAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused;

              if (isEngPaused || isEngAutoPaused || !navigator.onLine) {
                if (currentStatus) {
                  currentStatus.resumeData = {
                    nextBlock: thisBlockIndex,
                    blockIds: Array.from(stagedBlocks),
                  };
                }
                throw new PauseError("PAUSE_BEFORE_CHUNK_UPLOAD");
              }

              try {
                await blockBlobClient.stageBlock(blockId, block, block.size, {
                  abortSignal: batchAbort.signal,
                });
                stagedBlocks.add(blockId);
                updateUploadedCount(0, 0, block.size, 0);
                return;
              } catch (err) {
                const isOfflineLike =
                  !navigator.onLine ||
                  err?.name === "AbortError" ||
                  err?.message?.includes("Failed to fetch") ||
                  err?.code === "ECONNABORTED";

                if (isOfflineLike) {
                  const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
                  if (!status) throw err;

                  const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
                  const wasManuallyPaused = Boolean(status.isUploadPaused);

                  if (wasManuallyPaused || isEnagementPaused) {
                    status.resumeData = {
                      nextBlock: thisBlockIndex,
                      blockIds: Array.from(stagedBlocks),
                    };
                    try { batchAbort.abort(); } catch { }
                    throw new PauseError("PAUSE_MANUAL_ABORT");
                  } else {
                    status.isUploadAutoPaused = true;
                    status.resumeData = {
                      nextBlock: thisBlockIndex,
                      blockIds: Array.from(stagedBlocks),
                    };
                    try { batchAbort.abort(); } catch { }
                    throw new PauseError("PAUSE_OFFLINE_OR_ABORT");
                  }
                }

                if (err?.statusCode === 403 || err?.code === "AuthenticationFailed") {
                  await TokenManager.refreshToken();
                  sasData = TokenManager.getSasData();
                  token = TokenManager.getToken();
                  blockBlobClient = new BlockBlobClient(`${sasData.result.url}/${blobURL}?${token}`);
                  continue;
                }

                if (attempt < MAX_RETRIES - 1) {
                  await delay(backoffDelay(attempt));
                  attempt++;
                  continue;
                }

                throw err;
              }
            }
          };

          batchPromises.push(uploadChunk());
        }

        try {
          await Promise.all(batchPromises);
        } catch (err) {
          const isPause = err?.name === "PauseError" || err?.isPause === true;
          if (isPause) {
            const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
            if (status) {
              const hasFailedIndex =
                typeof err?.failedBlockIndex === "number" && err.failedBlockIndex >= 0;
              const fallbackIndex = Math.max(0, nextBlock - batchPromises.length);
              const failedBlockIndex = hasFailedIndex ? err.failedBlockIndex : fallbackIndex;

              status.resumeData = {
                nextBlock: failedBlockIndex,
                blockIds: Array.from(stagedBlocks)
              };
            }
            continue;
          }
          throw err;
        }
      }

      // Commit blocks
      let finalBlockList = Array.from(stagedBlocks).sort((a, b) => {
        const aNum = parseInt(atob(a).split('-')[1]);
        const bNum = parseInt(atob(b).split('-')[1]);
        return aNum - bNum;
      });

      // Verify all blocks before commit
      if (finalBlockList.length !== totalBlocks) {
        logger.warn(`Block count mismatch: staged ${finalBlockList.length}, expected ${totalBlocks}`);

        const stagedBlockNumbers = new Set(finalBlockList.map(id => parseInt(atob(id).split('-')[1])));
        for (let i = 0; i < totalBlocks; i++) {
          if (!stagedBlockNumbers.has(i)) {
            // CHECK PAUSE STATE BEFORE RETRYING MISSING BLOCKS
            const currentStatus = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
            const isEngPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
            const isEngAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused;

            if (isEngPaused || isEngAutoPaused || !navigator.onLine) {
              if (currentStatus) {
                currentStatus.resumeData = {
                  nextBlock: i,
                  blockIds: Array.from(stagedBlocks),
                };
              }
              await waitForResume().catch(() => { });
              i--; // Retry this block
              continue;
            }

            const start = i * BLOCK_SIZE;
            const end = Math.min(start + BLOCK_SIZE, file.size);
            const block = file.slice(start, end);
            const blockId = btoa(`block-${i.toString().padStart(6, "0")}`);

            let retryAttempt = 0;
            let staged = false;

            while (retryAttempt < MAX_RETRIES && !staged) {
              try {
                await blockBlobClient.stageBlock(blockId, block, block.size, {
                  abortSignal: getAbortController().signal,
                });
                stagedBlocks.add(blockId);
                updateUploadedCount(0, 0, block.size, 0);
                staged = true;
              } catch (err) {
                const isOfflineLike =
                  !navigator.onLine ||
                  err?.name === "AbortError" ||
                  err?.message?.includes("Failed to fetch") ||
                  err?.code === "ECONNABORTED";

                if (isOfflineLike) {
                  const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
                  if (!status) throw err;

                  const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
                  const wasManuallyPaused = Boolean(status.isUploadPaused);

                  if (wasManuallyPaused || isEnagementPaused) {
                    status.resumeData = {
                      nextBlock: i,
                      blockIds: Array.from(stagedBlocks),
                    };
                    throw new PauseError("PAUSE_MANUAL_ABORT");
                  } else {
                    status.isUploadAutoPaused = true;
                    status.resumeData = {
                      nextBlock: i,
                      blockIds: Array.from(stagedBlocks),
                    };
                    throw new PauseError("PAUSE_OFFLINE_OR_ABORT");
                  }
                }

                if (err?.statusCode === 403 || err?.code === "AuthenticationFailed") {
                  await TokenManager.refreshToken();
                  sasData = TokenManager.getSasData();
                  token = TokenManager.getToken();
                  blockBlobClient = new BlockBlobClient(`${sasData.result.url}/${blobURL}?${token}`);
                  retryAttempt++;
                  continue;
                }

                if (retryAttempt < MAX_RETRIES - 1) {
                  await delay(backoffDelay(retryAttempt));
                  retryAttempt++;
                  continue;
                }

                logger.error(`Failed to stage missing block ${i}:`, err);
                throw err;
              }
            }
          }
        }

        finalBlockList = Array.from(stagedBlocks).sort((a, b) => {
          const aNum = parseInt(atob(a).split('-')[1]);
          const bNum = parseInt(atob(b).split('-')[1]);
          return aNum - bNum;
        });

        logger.warn(`Block count after retry: staged ${finalBlockList.length}, expected ${totalBlocks}`);
      }

      // CHECK PAUSE STATE BEFORE COMMIT
      const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
      const isEngagementAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused;

      if (isEnagementPaused || isEngagementAutoPaused) {
        await waitForResume().catch(() => { });
      }

      try {
        await blockBlobClient
          .commitBlockList(finalBlockList)
          .then(() => generateMetadata(file, formData, updateUploadedCount, isRetry, transactionID));
      } catch (err) {
        let commitAttempt = 0;
        let commitSuccess = false;

        while (commitAttempt < MAX_RETRIES && !commitSuccess) {
          try {
            if (err?.statusCode === 403 || err?.code === "AuthenticationFailed") {
              await TokenManager.refreshToken();
              sasData = TokenManager.getSasData();
              token = TokenManager.getToken();
              blockBlobClient = new BlockBlobClient(`${sasData.result.url}/${blobURL}?${token}`);

              // CHECK PAUSE BEFORE RETRY COMMIT
              const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
              const isEngagementAutoPaused = engagementPauseStatus.current[engagementId]?.isUploadAutoPaused;

              if (isEnagementPaused || isEngagementAutoPaused) {
                await waitForResume().catch(() => { });
              }

              await blockBlobClient
                .commitBlockList(finalBlockList)
                .then(() => generateMetadata(file, formData, updateUploadedCount, isRetry, transactionID));

              commitSuccess = true;
              break;
            }

            const isOfflineLike =
              !navigator.onLine ||
              err?.name === "AbortError" ||
              err?.message?.includes("Failed to fetch") ||
              err?.code === "ECONNABORTED";

            if (isOfflineLike) {
              const status = engagementPauseStatus.current[engagementId]?.[uploadSessionId];
              if (!status) throw err;

              const isEnagementPaused = engagementPauseStatus.current[engagementId]?.isUploadPaused;
              const wasManuallyPaused = Boolean(status.isUploadPaused);

              if (wasManuallyPaused || isEnagementPaused) {
                status.resumeData = {
                  nextBlock: totalBlocks,
                  blockIds: Array.from(stagedBlocks),
                };
                throw new PauseError("PAUSE_MANUAL_ABORT");
              } else {
                status.isUploadAutoPaused = true;
                status.resumeData = {
                  nextBlock: totalBlocks,
                  blockIds: Array.from(stagedBlocks),
                };
                throw new PauseError("PAUSE_OFFLINE_OR_ABORT");
              }
            }

            commitSuccess = true;
          } catch (retryErr) {
            commitAttempt++;
            if (commitAttempt >= MAX_RETRIES) {
              throw retryErr;
            }
            await delay(backoffDelay(commitAttempt));
            err = retryErr;
          }
        }
      }
    } catch (error) {
      if (!isRetry) {
        setFailedUploads((prev) => [
          ...prev,
          {
            file: file,
            fileName: file.name,
            reason: error.name,
            message: error.message,
            errorCode: error.code || "",
            engagementID: rowData.engagementId,
            region: rowData.region,
            id: transactionID,
            attempts: 0,
            currentFlow: true,
            lastModifiedDate: new Date(file.lastModified).toISOString(),
            createdDate: new Date().toISOString().replace("Z", "").slice(0, 23),
            uploadedBy: getAccount().username,
          },
        ]);
      }

      const ext = file.path.split(".").pop();
      const errorFormData = {
        uploadType: ext,
        uploadFileName: file.name,
        uploadedBy: getAccount().username,
        region: rowData.area,
        reasonPhrase: error.message,
        errorMessage: error.code,
        errorCode: error.code,
        url: error.url || " ",
        additionalInfo: file.path ? file.path : file.name,
        engagementIdGUID: rowData?.engagementId_GUID || null,
        transactionID: transactionID,
        batchStatus: "Uploading",
        UploadId_GUID: UPLOADID_GUID,
      };

      if (!isRetry) {
        updateUploadedCount(0, 1, 0, file.size);
        try {
          SaveErrorLog(errorFormData);
        } catch { }
      }

      if (isRetry) {
        setShowProcessingPage(false);
        setDisableContinue(false);
        setFailedUploads((prev) =>
          prev.map((f) => (f.id === transactionID ? { ...f, attempts: f.attempts + 1 } : f))
        );
        setUploadingFileId(null);
      }
    } finally {
      try {
        cleanupListeners?.();
      } catch { }

      if (heartbeatIntervalId) {
        try {
          window.clearInterval(heartbeatIntervalId);
        } catch { }
        heartbeatIntervalId = null;
      }

      if (engagementPauseStatus.current[rowData.engagementId]?.[uploadSessionId]) {
        delete engagementPauseStatus.current[rowData.engagementId][uploadSessionId];
      }

      setShowProgress(false);
      setIsUploadDisabled(false);
    }
  };

  let totalCount = 0;
  let uploadedCount = 0;
  let failedCount = 0;
  const setTotalCount = (count) => {
    totalCount = count;
    originalTotalCountRef.current = count;
  }
  let totalSize = 0;
  let uploadedSize = 0;
  let failedSize = 0;
  const setTotalSize = (size) => {
    totalSize = size;
  }

  /* istanbul ignore next */
  const startValidationProccessing = async (controlIds, currentControlIds, isSPFileUpload) => {
    let stopped = false;

    const pollStatus = async () => {
      if (stopped) return;

      const data = await fetchFileStatus(controlIds, isSPFileUpload);

      if ((data && (data[0]?.totalFileProcessed === data[0]?.totalFileUploaded))) {
        stopped = true;
        setShowProgressPage(true);
        triggerEngagementUpdate(rowData.engagementId);
        ValidateUploadedFileStatus(currentControlIds);
        //uploadPercentage[rowData.engagementId].failedCount += data[0]?.totalFileFailed
        try {
          const response = await apiQueryWithToken.post(
            `api/errors/engagement?engagementIdGUID=${rowData?.engagementId_GUID}&isProcessingError=true`,
          );

          const responseData = response.data || [];
          setProcessingErrorStatus(response.status);
          const isNotDeleted = (file) =>
            !deletedFileKeys.current.has(file.errorId) &&
            !deletedFileKeys.current.has(file.controlId) &&
            !deletedFileKeys.current.has(file.transactionID);
          const newProcessingErrors = responseData.filter(file => {
            if (file.uploadId_GUID !== UPLOADID_GUID) return false;
            if (isNotDeleted(file) === false) return false;
            // Use functional-updater approach below; pre-filter here based on
            // the current failedUploads snapshot to avoid stale-closure duplicates.
            // Match on errorId, transactionID, OR controlId — reprocess failures
            // produce new errorIds but keep the same controlId.
            const alreadyTracked = failedUploads.some(
              item =>
                item.id === file.errorId ||
                (item.transactionID && item.transactionID === file.transactionID) ||
                (item.id && item.id === file.transactionID) ||
                (item.controlId && item.controlId === file.controlId)
            );
            return !alreadyTracked;
          });

          setFailedUploads((prev) => {
            // Re-check deduplication against the latest state (prev) to guard
            // against concurrent polling-loop closures with stale snapshots.
            const toAdd = newProcessingErrors.filter(file =>
              !prev.some(
                item =>
                  item.id === file.errorId ||
                  (item.transactionID && item.transactionID === file.transactionID) ||
                  (item.id && item.id === file.transactionID) ||
                  (item.controlId && item.controlId === file.controlId)
              )
            );
            if (toAdd.length === 0) return prev;
            return [
              ...prev,
              ...toAdd.map(file => ({
                file: { name: file?.uploadFileName, size: 0, path: "", batchStatus: file?.batchStatus || "" },
                fileName: file?.uploadFileName,
                reason: file?.reasonPhrase || "",
                message: file?.customErrorMessage || "",
                errorCode: file?.errorCode || "",
                engagementID: rowData.engagementId,
                region: rowData.region,
                id: file.errorId,
                attempts: 0,
                currentFlow: true,
                controlId: file.controlId,
                transactionID: file.transactionID || "",
                batchStatus: file?.batchStatus || "",
                uploadedBy: file?.uploadedBy || "",
                createdDate: file?.createdDate || new Date().toISOString().replace('Z', '').slice(0, 23),
              }))
            ];
          });
          if (newProcessingErrors.length > 0) {
            // Apply the failed-count delta against the latest committed state.
            // Reading the uploadPercentage prop directly here (from a stale
            // polling closure) previously re-peaked initialFailedCountRef with an
            // old absolute value, undoing the decrement done after a successful
            // "Re-upload all" (showed "2 files failed" when only 1 remained).
            setUploadPercentage((prev) => {
              const current = prev[rowData.engagementId] || {};
              return {
                ...prev,
                [rowData.engagementId]: {
                  ...current,
                  failedCount: (current.failedCount || 0) + newProcessingErrors.length,
                },
              };
            });
            initialFailedCountRef.current = initialFailedCountRef.current + newProcessingErrors.length;
          }
        }
        catch (error) {
          logger.error("Error fetching engagement errors:", error);
        }
        return;
      }



      setTimeout(pollStatus, 10000); // poll again after 10 seconds
    };

    pollStatus();
  };

  /* istanbul ignore next */
  const UploadFolders = async (selectedFiles, isRetry = false, failedtransactionID = "") => {
    isReuploadFlow.current = isRetry;
    if (!isRetry) retryMetadataControlIds.current.clear();
    setIsLoading(false);
    SetStartProcessImmediately(false);
    //SetUploadedControlIDs([]);
    if (!isRetry) {
      setShowProgress(true);
      setIsUploading(true);
    }

    setIsUploadDisabled(true);
    const validFiles = selectedFiles.filter(file => file.size > 0 && !file.isSPFile);
    setIsUploadDisabled(true);
    const spFilesUploaded = selectedFiles.filter(file => file.isSPFile);
    // Deduplicate SP files here too so total counts align with payload
    const dedupedSpFilesUploaded = Object.values(
      (spFilesUploaded || []).reduce((acc, file) => {
        const existing = acc[file.name];
        if (!existing || (file.lastModified || 0) > (existing.lastModified || 0)) {
          acc[file.name] = file;
        }
        return acc;
      }, {})
    );

    if (!isRetry) {
      setTotalCount(validFiles.length + dedupedSpFilesUploaded.length);
      setTotalSize(validFiles.reduce((acc, file) => acc + file.size, 0) + dedupedSpFilesUploaded.reduce((acc, file) => acc + file.size, 0));
    }

    const updateUploadedCount = (sucess, failed, successByte = 0, failedByte = 0) => {
      if (isRetry) {
        // Re-upload path: apply deltas against the latest committed state via the
        // functional updater. Reading the uploadPercentage prop directly caused a
        // stale-closure race during "Re-upload all" (each re-uploaded file
        // overwrote the same base value, so only one file was ever counted).
        if (sucess > 0) {
          initialFailedCountRef.current = Math.max(0, initialFailedCountRef.current - sucess);
        }
        setUploadPercentage(prev => {
          const current = prev[rowData.engagementId] || {};
          return {
            ...prev,
            [rowData.engagementId]: {
              ...current,
              engagementId: rowData.engagementId,
              uploadedCount: (current.uploadedCount || 0) + sucess,
              failedCount: Math.max(0, (current.failedCount || 0) - sucess + failed),
              uploadedSize: (current.uploadedSize || 0) + successByte,
              failedSize: Math.max(0, (current.failedSize || 0) - successByte + failedByte),
            },
          };
        });
        return;
      }

      uploadedCount += sucess;
      failedCount += failed;
      if (failed > 0) initialFailedCountRef.current = Math.max(initialFailedCountRef.current, failedCount);
      uploadedSize += successByte;
      failedSize += failedByte;

      const percent = Math.round(((uploadedCount + failedCount) / totalCount) * 100);
      const percentSize = Math.round(((uploadedSize + failedSize) / totalSize) * 100);

      // Auto-process trigger:
      // Previously required uploadedCount >= 1 which blocks protected-only (metadata-only) uploads.
      // Allow case where percent==100 and totalCount>0 even if uploadedCount==0.
      if (percent === 100 && (uploadedCount >= 1 || (totalCount > 0 && uploadedCount === 0))) {
        setShowProcessingPage(true);
        triggerEngagementUpdate(rowData.engagementId);

        const process = initiateAutoProcess.current.find(
          (p) => p.engID === rowData.engagementId
        );

        if (process) {
          // If we have zero uploadedCount but totalCount>0, we still want to initiate.
          process.shouldInitiate = true;
          // Preserve original startProcessImmediately behavior when files actually uploaded.
          if (uploadedCount >= 1) {
            process.shouldInitiate = startProcessImmediately;
          }

        }


      }

      setUploadPercentage(prev => ({
        ...prev,
        [rowData.engagementId]: {
          percent: percent,
          totalCount: totalCount,
          uploadedCount: uploadedCount,
          engagementId: rowData.engagementId,
          failedCount: failedCount,
          percentSize: percentSize,
          totalSize: totalSize,
          uploadedSize: uploadedSize,
          failedSize: failedSize,
        }
      }));
    };

    if (files?.some(f => f.isSPFile)) {
      setIsSPFileUpload(true);
      // Pass non-SP count so SP payload can report combined total
      handleSPUpload(updateUploadedCount, dedupedSpFilesUploaded, validFiles.length);
    }

    const totalFilesSize = validFiles.reduce((acc, file) => acc + file.size, 0);
    const startProcessImmediately = totalFilesSize < 2 * 1024 * 1024 * 1024; // 100MB threshold


    // if (!isRetry) {
    const process = initiateAutoProcess.current.find(
      (p) => p.engID === rowData.engagementId
    );
    if (process) {
      process.uploadID = [];
      process.hasInitiated = false;
      process.shouldInitiate = false;
      process.Region = rowData?.area;
      process.pwdSkipped = pwdSkipped.current;
      process.engLevelPwd = engLevelPwd;
    }
    else {
      initiateAutoProcess.current.push({
        engID: rowData.engagementId,
        uploadID: [],
        hasInitiated: false,
        shouldInitiate: false,
        Region: rowData?.area,
        pwdSkipped: pwdSkipped.current,
        engLevelPwd: engLevelPwd
      });
    }

    // }
    SetStartProcessImmediately(startProcessImmediately);

    updateUploadedCount(0, 0);

    const gicsSelection = resolveGicsSelection(userData?.gicsSectorMappings, rowData);
    const ccsValues = rowData.ccs;

    // Create a mapping of CCS names to their IDs
    const ccsMap = {};
    userData?.ccs?.forEach(item => {
      ccsMap[item.ccsType] = item.ccsId;
    });

    // Split the CCS values and map them to their corresponding IDs
    const ccsIds = ccsValues.split(', ').map(ccsName => ccsMap[ccsName.trim()]).filter(id => id !== undefined);

    // Join the IDs into a comma-separated string
    const ccsIdsString = ccsIds.join(', ');

    let region = '';
    if (rowData?.country === UNITED_KINGDOM) {
      region = 'EMEIA';
    } else {
      region = rowData?.area;
    }

    const uploadQueue = [];
    let sasData = await getSasToken(getAccount()?.username);

    for (const file of validFiles) {
      let rootFolder = '';
      let relativePath = '';

      if (file.path && file.path.includes("/")) {
        const cleanPath = file.path.replace(/^\/+/, ""); // Remove leading slash
        const pathParts = cleanPath.split("/"); // Split path into parts
        rootFolder = pathParts[0];
        pathParts.pop(); // remove file name
        relativePath = pathParts.join("/") + "/";
      }

      if (rowData.sortCodes == "10949") {
        if (!SNSTransactionID.current[rootFolder]) {
          SNSTransactionID.current[rootFolder] = rootFolder;
        }

        if (!SNSTransactionID.current[relativePath]) {
          SNSTransactionID.current[relativePath] = generateGUID();
        }
      }

      const transactionID = isRetry ? failedtransactionID : generateGUID();
      const isZip = file.name.toLowerCase().endsWith(".zip");
      const ZIP_REPO = 'ZipFilesRepo';
      const FILES_REPO = 'DBSFolderandFileRepo';
      const UIDBSFolderandFileRepo = 'UIDBSFolderandFileRepo';

      if (!file) return;

      const blobURL = `${startProcessImmediately ? UIDBSFolderandFileRepo : isZip ? ZIP_REPO : FILES_REPO}/${transactionID}.${file.name.split('.').pop()}`

      /*Constructing Form Data */
      const formData = new FormData();
      formData.append("ModifiedBy", "Test");
      formData.append("Region", rowData?.area);
      formData.append("EngagementId", rowData.engagementId);
      formData.append("UserID", 12);
      appendGicsUploadFields(formData, gicsSelection);
      formData.append("UserEmailID", getAccount()?.username);
      formData.append("CCS", ccsIdsString);
      formData.append("Country", rowData.country);
      formData.append("projectName", rowData.engagementName);
      formData.append("clientName", rowData.clientName);
      formData.append("Function", "Default");
      formData.append("Config_file", "config");
      formData.append("Revenue", rowData.revenueRange);
      formData.append("SSLCompetancy", rowData.ssl);
      formData.append("CreatedBy", getAccount()?.name);
      formData.append("NewRegion", rowData?.region);
      formData.append("Area", rowData.area);
      formData.append("Exsists", true);
      formData.append("EngagementId_GUID", rowData?.engagementId_GUID);
      formData.append("targetArea", rowData?.targetArea);
      formData.append("targetCountry", rowData?.targetCountry);
      formData.append("targetRegion", rowData?.targetRegion);
      formData.append("sortCodes", rowData?.sortCodes);
      formData.append("FreeTextTags", rowData?.freeTextTags);
      formData.append("IsEyOwnFolder", true);
      formData.append("IsClientDataFolder", isClientEngagement);
      formData.append("IsCorrectPasword", false);
      formData.append("IsRetry", isRetry);
      formData.set("BlobFileName", blobURL);
      formData.set("isZip", isZip)
      formData.set("Path", file.path.replace(/^\/+/, ""));
      formData.set("Filename", file.name);
      formData.set('TransactionID', transactionID);
      formData.set("ContentType", getMimeType(file.name));
      formData.set("UploadId_GUID", UPLOADID_GUID);
      formData.set("SNSRootFolderName", SNSTransactionID.current[rootFolder] || null);
      formData.set("SNSUploadId_GUID", SNSTransactionID.current[relativePath] || null);
      formData.set("eng_password", pwdSkipped.current ? '' : engLevelPwd);
      formData.set("FileModifiedDate", new Date(file.lastModified).toISOString());
      formData.set("FileSize", (file.size / (1024 * 1024)).toFixed(2));
      formData.set("IsOverrideFile", overrideFiles.current === true ? true : false);

      const uploadFn = () => {
        return uploadFile(file, sasData, updateUploadedCount, isRetry, blobURL, transactionID, formData);
      }

      // Decide concurrency per file
      if (file.size > 500 * 1024 * 1024) {
        // >500MB → single upload, wait for finish                
        try {
          await uploadFn();
        }
        catch (error) {
          logger.error(`Error uploading large file ${file.name}:`, error);
        }
      } else {
        // <500MB → add to parallel queue        
        uploadQueue.push(uploadFn);
      }
    }

    // Run smaller files in parallel (limit concurrency)
    const pLimit = (limit) => {
      const queue = [];
      let activeCount = 0;

      const next = () => {
        if (queue.length === 0 || activeCount >= limit) return;

        activeCount++;
        const fn = queue.shift();
        fn().finally(() => {
          activeCount--;
          next();
        });
        next();
      };

      return (fn) => {
        return new Promise((resolve, reject) => {
          queue.push(() => fn().then(resolve).catch(reject));
          next();
        });
      };
    };

    const limiter = pLimit(10); // Limit to 10 parallel uploads
    const protectedFilesArrays = await Promise.allSettled(uploadQueue.map((fn) => limiter(fn)));

    if (failedUploads.length < 1) {
      setShowProgress(false);
      setIsUploadDisabled(false);
    }

    return protectedFilesArrays;
  };

  //  const UPLOADID_GUID = generateGUID();
  /* istanbul ignore next */
  const handleUploadClick = async () => {

    if (files.length === 0) {
      logger.info("No files to upload.");
      return;
    }

    // Filter out duplicate files, keeping only the latest modified version
    const uniqueLatestFiles = Object.values(
      files.reduce((acc, file) => {
        const existing = acc[file.name];
        // Keep file with latest modified date
        if (!existing || new Date(file.lastModifiedDate) > new Date(existing.lastModifiedDate)) {
          acc[file.name] = file;
        }
        return acc;
      }, {})
    );


    //list down files to skip based on user choice in duplicate dialog
    const skipFileNames = overrideFiles.current === false
      ? duplicateFiles.current.map(file => file.fileName)
      : duplicateFiles.current
        .filter(file => file.isMoved)
        .map(file => file.fileName);

    const filteredFiles = uniqueLatestFiles.filter(file => !skipFileNames.includes(file.name));
    setFiles(filteredFiles);
    if (filteredFiles.length === 0) {

      setFiles([]);
      onClose();
      setNextPwdPage(true);
      return;
    }


    setShowProgressPage(true);
    const allNewProtectedFiles = await UploadFolders(filteredFiles);
    if (attemptedBlockedFiles.length > 0) {
      saveBlockedFilesList();
    }
  }

  /* istanbul ignore next */
  const handleDuplicateConfirmation = (override) => {

    overrideFiles.current = override;
    handleUploadClick();
    setOpenDuplicateDialog(false);
  }
  // to get duplciate files from the uploaded files
  const getDuplicateFilesData = () => {
    setIsLoading(true);
    const fileNamesString = files.map(file => file.name);
    const formJSONData = {
      EngagementGuid: rowData.engagementId_GUID,
      uploadFileNames: fileNamesString
    }
    if(baseURL === process.env.REACT_APP_API_URL_US){
      dispatch(partnersDuplicateFilesRequestUS(formJSONData));
    }
      else if (baseURL === process.env.REACT_APP_API_URL_EU) {
      dispatch(partnersDuplicateFilesRequestEU(formJSONData));
      } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
      dispatch(partnersDuplicateFilesRequestAU(formJSONData));
      }
  };

  useEffect(() => {
    if(partnersDuplicateFilesData?.status === ApiStatus.SUCCESS){
      setIsLoading(false);

        if (files.length > 0 && (partnersDuplicateFilesData?.data.length > 0 || files.filter(file => file.name.toLowerCase().endsWith(".zip")).length > 0)) {
          duplicateFiles.current = partnersDuplicateFilesData?.data.filter(item => !item.fileName.endsWith(".zip"));
          submittedDuplicateFiles.current = duplicateFiles.current.some(dup => dup.isMoved);
          nonsubmittedDuplicateFiles.current = duplicateFiles.current.some(dup => !dup.isMoved);
          setOpenDuplicateDialog(true);
        }
        else {
          handleUploadClick();
        }
    } else if(partnersDuplicateFilesData?.status === ApiStatus.ERROR){
      setIsLoading(false);
    }
  }, [partnersDuplicateFilesData?.status])
  /* istanbul ignore next */
  const saveBlockedFilesList = () => {
    setIsLoading(true);
    apiQueryWithToken
      .post(`api/partners/insertUnsupportedFileTypes`, { "extension": attemptedBlockedFiles.join(","), "email": getAccount()?.username, "engagementID": rowData.engagementId_GUID })
      .then((data) => {

      })
      .catch((error) => {

        logger.error("An error occurred:", error);

      });
  };
  /* istanbul ignore next */
  const listFilesInZip = async (zip, pathPrefix = "", leadingPath = "") => {
    let zipStructure = {};

    const filePromises = Object.keys(zip.files).map(async (filename) => {
      const file = zip.files[filename];
      const relativePath = filename.split("/");
      const fullPath = [leadingPath, pathPrefix, ...relativePath].filter(Boolean).join("/").replace("//", "/");
      const extension = filename.substr(filename.lastIndexOf(".") + 1).toLowerCase();
      const isBlockedFile = blockedFileList.some(
        item => item.extension.toLowerCase() === extension.toLowerCase()
      );
      if (!file.dir && !isBlockedFile) {

        if (extension === "zip") {
          try {
            const content = await file.async("arraybuffer");
            const nestedZip = await JSZip.loadAsync(content);
            zipStructure[filename] = await listFilesInZip(nestedZip, fullPath);
          } catch (error) {
            logger.error(`Error processing ZIP file "${filename}":`, error);
            const protectedZipContent = await file.async("blob");
            const protectedFile = new File([protectedZipContent], filename.split("/").pop(), { type: "application/zip" });
            protectedFile.path = fullPath;
            addToStructure(zipStructure, relativePath, protectedFile, true, fullPath);
            setFileProtectionStatus((prevStatus) => ({
              ...prevStatus,
              [fullPath]: true, // Update the file's protection status to unprotected
            }));
          }
        } else {
          const fileContent = await file.async("blob");
          const extractedFile = new File([fileContent], filename.split("/").pop(), { type: fileContent.type });
          extractedFile.path = fullPath;
          addToStructure(zipStructure, relativePath, extractedFile);

        }
      }
    });

    await Promise.all(filePromises);
    return zipStructure;
  };

  /* istanbul ignore next */
  const insertZipContentIntoStructure = (structure, filePath, zipContent, isProtected = false) => {
    // Extract leading path before the ZIP file
    const leadingPath = filePath.substring(0, filePath.lastIndexOf("/") + 1);

    // Split path into an array (folder structure)
    const pathParts = leadingPath.split("/").filter(part => part !== ""); // Remove empty parts

    let currentLevel = structure;

    // Traverse and build the structure
    pathParts.forEach((part) => {
      if (!currentLevel[part]) {
        currentLevel[part] = {}; // Create folder if not exists
      }
      currentLevel = currentLevel[part]; // Move deeper
    });
    if (!isProtected) {
      currentLevel[filePath.split("/").pop()] = {
        ...zipContent,
        path: filePath
      };
    }
    else {
      // Extract the ZIP filename
      const zipFileName = filePath.split("/").pop();

      // Ensure the ZIP file itself is stored as a `File` object
      if (!currentLevel[zipFileName] || !(currentLevel[zipFileName] instanceof File)) {
        const zipFile = new File([zipContent], zipFileName, { type: "application/zip" });
        zipFile.path = filePath;
        currentLevel[zipFileName] = isProtected
          ? Object.assign(zipFile, {
            error: true,
            isFileProtected: true,
            password: "",
            content: null,
            path: filePath
          })
          : zipFile;
      }
    }
  };
  const onDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
    setFileEvaluatingMsg(true);
    setEvaluationProgress(0);

  }
  const onDragLeave = () => {
    setIsDragging(false);
    setFileEvaluatingMsg(false);

  };

  /* istanbul ignore next */
  const countFilesInZip = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const zip = await JSZip.loadAsync(data);
      return Object.values(zip.files).filter(f => !f.dir).length;
    } catch (err) {

      return 1; // count protected zip as 1 file
    }
  };
  /* istanbul ignore next */
  const countFiles = async (files) => {
    const zipFiles = files.filter(f => f.name.toLowerCase().endsWith(".zip"));
    const normalFiles = files.filter(f => !f.name.toLowerCase().endsWith(".zip"));

    // Split into zips vs normal files

    // Count normal files directly
    let totalCount = normalFiles.length;

    // Count files inside zips (parallelized)
    const zipCounts = await Promise.all(zipFiles.map(countFilesInZip));
    totalCount += zipCounts.reduce((a, b) => a + b, 0);

    return totalCount;
  };

  const onDrop = async (selectedFiles) => {
    setIsLoading(true);
    setIsDragging(false);
    setEvaluationProgress(100);
    setFileEvaluatingMsg(false);
    setEvaluationProgress(0);
    if (selectedFiles && selectedFiles.length > 0) {
      // Calculate the total size of all selected files
      const totalSizeN = selectedFiles.reduce((sum, file) => sum + file.size, 0);
      const totalEmptyFiles = selectedFiles.filter(file => file.size === 0).length;
      // Set ValidFile to true if total size is greater than zero
      ValidFile = totalSizeN > 0;

      if (ValidFile) {
        if (selectedFiles.filter(file => file.size == 0).length > 0) {
          setAlertMessage("Any empty folders/files in your upload have been automatically ignored.");
          setOpenAlertDialog(true);
        }
        const validFiles = selectedFiles.filter(file => file.size > 0);
        selectedFiles = validFiles; // Uncomment this line if you want to update the original array
      } else {
        if (totalEmptyFiles < 2) {
          setAlertMessage("File is empty. Please upload a valid file.");

        } else {
          setAlertMessage("All files are empty. Please upload valid files.");
        }
        setIsLoading(false);
        setOpenAlertDialog(true);
        return;
      }

    }

    setIsLoading(true);
    //setProgress(0);
    let newBlockedFiles = false;
    let newBlockedFilesList = [];
    let newZipAdd = false;

    setshoWBreadcrumb(true);
    setCurrentPath([]);


    // if (!selectedFiles.every(file => file instanceof File && 'name' in file)) {
    //   console.error('One or more selected files do not have a name property');
    //   return;
    // }
    /*Check for Blocked */
    selectedFiles.forEach((file) => {
      const extension = file?.path.substr(file?.path.lastIndexOf(".") + 1).toLowerCase();
      if (extension === "zip") {
        newZipAdd = true;
      }
      const isBlockedFile = blockedFileList.some(
        item => item.extension.toLowerCase() === extension.toLowerCase()
      );
      if (isBlockedFile) {
        newBlockedFiles = true;
        !attemptedBlockedFiles.includes(extension) && attemptedBlockedFiles.push(extension);
        !newBlockedFilesList.includes(extension) && newBlockedFilesList.push(extension);
      }
    });
    const errorMessage = `EY policy prohibits the upload of executable files to DBS; therefore, only non-executable files have been uploaded.`


    selectedFiles = selectedFiles.filter(file => {
      const extension = file?.path.substr(file?.path.lastIndexOf(".") + 1).toLowerCase();
      return !attemptedBlockedFiles.includes(extension);

    })
    if (selectedFiles.length === 0) {
      setIsLoading(false);
    }
    let newStructure = { ...fileStructure };
    let allextractedFiles = [];

    const matchingFiles = getSameFiles(selectedFiles, files, 'path');
    const newFiles = removeCommonFiles(selectedFiles, matchingFiles, 'path');
    const totalUploadSize = files.reduce((acc, file) => acc + file.size, 0) + newFiles.reduce((acc, file) => acc + file.size, 0);
    // Check if all files (existing + new) are SharePoint files
    const allFiles = [...files, ...newFiles];
    const allAreSPFiles = allFiles.length > 0 && allFiles.every(f => f.isSPFile);

    let totalnumberOfFiles = 0;
    if (allAreSPFiles) {
      // If all files are SharePoint files, skip file count limit
      totalnumberOfFiles = 0;
    } else {
      // If mixed or all are not SP files, count them
      totalnumberOfFiles = await countFiles(allFiles);
    }
    /* istanbul ignore next */
    if (totalnumberOfFiles > 1500) {
      setIsLoading(false);
      // setIsUploadDisabled(false);
      setAlertMessage("File upload limit exceeded. You can upload a maximum of 1500 files at a time. Please reduce the number of files and try again.");
      setPageReload(false);
      setOpenAlertDialog(true);
      return;
    } else /* istanbul ignore next */ if (totalUploadSize > 50 * 1024 * 1024 * 1024) {

      setIsLoading(false);
      // setIsUploadDisabled(true);
      setAlertMessage("Uploads exceeding 50GB cannot be processed. Please divide your upload into smaller segments before uploading.");
      setPageReload(false);
      setOpenAlertDialog(true);
      return;
    }
    if (selectedFiles.length > 0 || files.length > 0)
      setIsUploadDisabled(false);

    newFiles.forEach((file) => {
      // Check if the file is a ZIP and larger than 2 GB
      /* istanbul ignore next */
      if (file.path.endsWith('.zip') && file.size > 50 * 1024 * 1024 * 1024) { // 2 GB in bytes
        file["error"] = true;
        file["errorMessage"] = "Uploads exceeding 50GB cannot be processed. Please divide your upload into smaller segments before uploading.";
      }
    });

    const invalidFiles = newFiles.some(file => file.error === true);
    if (!invalidFiles) {

      // Process non-ZIP files
      selectedFiles.forEach((file) => {
        if (!file.path.endsWith(".zip")) {
          const pathParts = file.path
            ? file.path.replace(/^\/+/, "").split("/")
            : [file.name];
          let currentLevel = newStructure;
          let accumulatedPath = "";
          pathParts.forEach((part, index) => {
            const cleanPart = part.replace(/^\/+|\/+$/g, "");
            accumulatedPath += (accumulatedPath ? "/" : "") + cleanPart;
            if (index === pathParts.length - 1) {
              // If it's the last part, it's a file, store it properly
              if (!currentLevel[part]) {
                currentLevel[part] = file;
              }
            } else {
              // If it's a folder, create it if it doesn't exist
              if (!currentLevel[part]) {
                currentLevel[part] = {

                  path: accumulatedPath
                };
              }
              currentLevel = currentLevel[part]; // Move to the next folder level
            }
          });
        }
      });


      setFileStructure(newStructure);

      if (totalUploadSize <= 50 * 1024 * 1024 * 1024 && totalUploadSize > 0 && totalnumberOfFiles <= 1500) { // 750 MB in bytes

        // setShowUploads(true);

        setIsUploadDisabled(false);
        setIsLargeZipFile(false);
        setFiles([...files, ...newFiles]);
        setExtractedFiles(prevExtractedFiles => [...prevExtractedFiles, ...allextractedFiles]);
        setIsLoading(false);


      }
      /* istanbul ignore next */
      else if (totalUploadSize > 0) {
        setAlertMessage("Uploads exceeding 50GB cannot be processed. Please divide your upload into smaller segments before uploading.");
        setPageReload(false);
        setOpenAlertDialog(true);
        // setFiles([]);
        setIsLoading(false);
      }

      // });
    }
    if (newBlockedFiles || newZipAdd) {

      setAlertMessage(errorMessage);
      setOpenAlertDialog(true);
    }
  };

  const getCurrentFolderContents = (searchTerm = "") => {
    let currentProtectedFilesStructure = ''; //  ;
    let currentFileStructure = fileStructure;

    /* istanbul ignore next */
    if (isContinueClicked && protectedFiles.length && !isSkipContinueClicked > 0) {
      const filteredFiles = protectedFiles.filter(file => {
        const name = file?.name?.toLowerCase() || '';
        const term = searchTerm?.toLowerCase() || '';
        return name.includes(term);
      });
      currentProtectedFilesStructure = buildFileStructure(filteredFiles);
    }
    else {
      /* istanbul ignore next */
      if (isContinueClicked) {
        currentFileStructure = buildFileStructure([...files, ...extractedFiles].filter((file) => file.name.toLowerCase().includes(searchTerm.toLowerCase())))

      }
      else {
        currentFileStructure = buildFileStructure([...files, ...extractedFiles].filter((file) => file.name.toLowerCase().includes(searchValue.toLowerCase())))
      }
    }


    let currentLevel = (isContinueClicked && protectedFiles.length && !isSkipContinueClicked > 0) ? currentProtectedFilesStructure : currentFileStructure;

    for (const part of currentPath) {
      currentLevel = currentLevel[part] || {};
    }
    return currentLevel;
  };
  const navigateToFolder = (folderName) => {

    !isUnlocking && setCurrentPath([...currentPath, folderName]);
  };
  const goBack = (index) => {
    setCurrentPath(currentPath.slice(0, index + 1));
  };
  /* istanbul ignore next */
  const removeFile = (filePath, isFile = false) => {
    const normalizedFilePath = filePath.startsWith("/") ? filePath.slice(1) : filePath;

    // Remove from files array
    const updatedFiles = files.filter(f => {
      const normalizedFile = f.path.startsWith("/") ? f.path.slice(1) : f.path;
      return isFile
        ? normalizedFile !== normalizedFilePath
        : !normalizedFile.startsWith(normalizedFilePath);
    });

    const updatedExtractedFiles = extractedFiles.filter(f => {
      const normalizedFile = f.path.startsWith("/") ? f.path.slice(1) : f.path;
      return isFile
        ? normalizedFile !== normalizedFilePath
        : !normalizedFile.startsWith(normalizedFilePath);
    });
    const updatedPasswords = Object.fromEntries(
      Object.entries(passwords).filter(([key]) => {
        const normalizedKey = key.startsWith("/") ? key.slice(1) : key;
        return isFile
          ? normalizedKey !== normalizedFilePath
          : !normalizedKey.startsWith(normalizedFilePath);
      })
    );
    setPasswords(updatedPasswords);
    const updatedFileProtectionStatus = Object.fromEntries(
      Object.entries(fileProtectionStatus).filter(([key]) => {
        const normalizedKey = key.startsWith("/") ? key.slice(1) : key;
        return isFile
          ? normalizedKey !== normalizedFilePath
          : !normalizedKey.startsWith(normalizedFilePath);
      })
    );
    setFileProtectionStatus(updatedFileProtectionStatus);
    const updatedShowrroMessage = Object.fromEntries(
      Object.entries(showErrorMessage).filter(([key]) => {
        const normalizedKey = key.startsWith("/") ? key.slice(1) : key;
        return isFile
          ? normalizedKey !== normalizedFilePath
          : !normalizedKey.startsWith(normalizedFilePath);
      })
    );
    setshowErrorMessage(updatedShowrroMessage);
    const updatedisCorrectPassword = Object.fromEntries(
      Object.entries(isCorrectpasswords).filter(([key]) => {
        const normalizedKey = key.startsWith("/") ? key.slice(1) : key;
        return isFile
          ? normalizedKey !== normalizedFilePath
          : !normalizedKey.startsWith(normalizedFilePath);
      })
    );
    setIsCorrectPasswords(updatedisCorrectPassword);
    setFiles(updatedFiles);
    setExtractedFiles(updatedExtractedFiles);
    setFileStructure(buildFileStructure([...updatedFiles, ...updatedExtractedFiles]));
    //if (files.length === 1) {
    if (files.length === 0) {
      setIsUploadDisabled(true);
      setIsContinueClicked(false);
      setIsSkipContinueClicked(false);
    }

    const updatedProtectedFiles = protectedFiles.filter(f => {
      const normalizedFile = f.path.startsWith("/") ? f.path.slice(1) : f.path;
      return isFile
        ? normalizedFile !== normalizedFilePath
        : !normalizedFile.startsWith(normalizedFilePath);
    });
    setProtectedFiles(updatedProtectedFiles);

    // Disable upload button if no files left
    if (updatedFiles.length === 0) {
      setIsUploadDisabled(true);
      setIsContinueClicked(false);
      setIsSkipContinueClicked(false);
    }

  };
  const buildFileStructure = (files) => {
    const fileTree = {};

    const findFirstZipIndex = (parts) =>
      parts.findIndex(part => part.toLowerCase().endsWith(".zip"));

    files.forEach(file => {
      if (typeof file === 'object' && file !== null) {
        const cleanPath = file.path.replace(/^\/+/, "");
        const pathParts = cleanPath.split("/");
        let currentLevel = fileTree;
        let accumulatedPath = ""
        let accumulatedParts = [];

        const firstZipIndex = findFirstZipIndex(pathParts);

        pathParts.forEach((part, index) => {
          accumulatedPath += (index === 0 ? "" : "/") + part;
          accumulatedParts.push(part);
          const isInsideZip = firstZipIndex >= 0 && index > firstZipIndex;

          if (index === pathParts.length - 1) {

            currentLevel[part] = file
            currentLevel[part].isPartZip = isInsideZip
          } else {

            if (!currentLevel[part]) {
              const folderPath = accumulatedPath;
              currentLevel[part] = {
                path: folderPath,
                ...(isInsideZip && { isPartZip: true })
              };
            }
            currentLevel = currentLevel[part];
          }
        });
      }
    });

    /* istanbul ignore next */
    const recursiveUpdate = (folder) => {
      let isAnyFileProtected = false;

      for (const key in folder) {
        if (key === 'path' || key === 'isLocked' || key === 'type') continue;

        const entry = folder[key];

        if (entry && typeof entry === "object") {
          let showZipAsFile = true;
          if (key.endsWith(".zip")) {
            showZipAsFile = !extractedFiles.some(item => item.path.startsWith(entry.path + "/"));
          }
          if ((entry instanceof File && showZipAsFile)) {

            const isProtected = fileProtectionStatus[entry.path];
            const isPasswordCorrect = isCorrectpasswords[entry.path];
            if (isProtected && !isPasswordCorrect) {
              isAnyFileProtected = true;
            }

          } else {
            const childProtected = recursiveUpdate(entry);
            if (childProtected) {
              isAnyFileProtected = true;
            }
          }
        }
      }

      folder.isLocked = isAnyFileProtected;
      return isAnyFileProtected;
    };

    // Clone the top-level structure
    const updatedFileStructure = { ...fileTree };
    recursiveUpdate(updatedFileStructure);

    return updatedFileStructure;
  };

  /* istanbul ignore next */
  const hasProtectedFiles = files.some(file =>
    fileProtectionStatus[file.path] === true ||
    Object.keys(fileProtectionStatus).some(protectedPath => protectedPath.startsWith(file.path + "/"))
  );

  /* istanbul ignore next */
  const handleFolderUnlock = async (filePath) => {
    setIsUnlocking(true);
    const normalizedFilePath = filePath.startsWith("/") ? filePath.slice(1) : filePath;
    const currentFolderName = normalizedFilePath.split("/").pop();
    const nestedProtectedFiles = protectedFiles.filter(f => {
      const normalizedFile = f.path.startsWith("/") ? f.path.slice(1) : f.path;
      return normalizedFile.startsWith(normalizedFilePath);
    });
    const folderPasswordValue = passwords[normalizedFilePath];
    const updatedPasswords = nestedProtectedFiles.reduce((acc, file) => {
      const normalized = file.path.replace(/^\/+/, '').replace(/\/{2,}/g, '/');
      // Set file-level password
      acc[file.path] = folderPasswordValue;

      // Add folder path password(s)

      const parts = normalized.split('/');
      for (let i = 0; i < parts.length - 1; i++) {
        const folderPath = parts.slice(0, i + 1).join('/');
        acc[folderPath] = folderPasswordValue;
      }


      return acc;
    }, {});
    setPasswords((prevPasswords) => ({
      ...prevPasswords,
      ...updatedPasswords,
    }));

    const unlockPromises = nestedProtectedFiles.map(file => handleFile(file, folderPasswordValue, currentFolderName));
    await Promise.all(unlockPromises);

    navigateToFolder(currentFolderName);
    setIsUnlocking(false);

  };
  /* istanbul ignore next */
  const validateFilePassword = async (filesWithPasswords) => {
    const formData = new FormData();
    // Append files and their passwords to FormData
    filesWithPasswords.forEach(({ file, passwordValue }) => {
      formData.append("Files", file);
      formData.append("Password", passwordValue); // Assuming the API expects passwords in a separate field
    });

    try {
      // const response = await apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/FileValidation`, formData);
      // return response.data;
      return await partnersFileValidationData?.data;
    } catch (error) {
      logger.error("File validation failed:", error);
      return null; // Return null on error
    } finally {

    }
  };

  useEffect(() => {
    if (failedUploads.length === 0) {
      setShowUploadData(true);
    }
  }, [failedUploads])

  /* istanbul ignore next */
  const handleFile = async (file, passwordValue, unlockedFolder) => {
    const filePath = file.path;
    if (file.name.endsWith(".zip")) {
      //await handleUnlockZipFile(file.path, true, unlockedFolder, passwordValue, false)

      return; // Exit the function early
    }

    // Create an array with the file and its password
    const filePassword = passwordValue;
    const filesWithPasswords = [{ file, passwordValue }];


    // Call the validateFiles function with the array
    const response = await validateFilePassword(filesWithPasswords);

    // onUnlockFile(file.name);
    setIsCorrectPasswords((prevPasswords) => ({
      ...prevPasswords,
      [file.path]: response[0]?.isPasswordTrue,
    }));
    if (response[0]?.isPasswordTrue === false) {
      // If the password is incorrect, open the dialog
      //setOpenDialog(true);
      setshowErrorMessage((prevPasswords) => ({
        ...prevPasswords,
        [file.path]: true,
      }));
      return { path: file.path, success: false };
    }

    else {
      setFileProtectionStatus((prevStatus) => ({
        ...prevStatus,
        [file.path]: false, // Update the file's protection status to unprotected
      }));
      setshowErrorMessage((prevPasswords) => ({
        ...prevPasswords,
        [file.path]: false,
      }));

      setProtectedFiles(prevProtectedFiles => prevProtectedFiles.filter(file => file.path !== filePath));


    }
    return { path: file.path, success: true };

  };
  /* istanbul ignore next */
  useEffect(() => {
    const progress = uploadPercentage[rowData.engagementId] || {};
    if (allProtectedFiles.length > 0 && progress.percent === 100 && uploadComplete !== true && failedUploads.length == 0 && showProgressPage) {
      setCurrentPath([]);
      SetUploadComplete(true);
      setShowProgressPage(false);
      engagementPauseStatus.current[rowData.engagementId] = {
        isUploadPaused: false,
        isUploadAutoPaused: false,           
        uploadCount: progress.uploadedCount
      };
    }
  }, [allProtectedFiles, uploadPercentage, showProgressPage]);

  /* istanbul ignore next */
  useEffect(() => {
    const progress = uploadPercentage[rowData.engagementId] || {};
    if (progress.percent === 100) {
      const process = initiateAutoProcess.current.find(
        (p) => p.engID === rowData.engagementId
      );

      if (!isReuploadFlow.current && startProcessImmediately && !process.hasInitiated && uploadedControlIDs.length>0 && retryState.current.completed === retryState.current.total) {
        const process = initiateAutoProcess.current.find(
          (p) => p.engID === rowData.engagementId
        );

        if (process) {
          process.hasInitiated = true;

        }
        initiateProcess(uploadedControlIDs, false);
        setProcessingResult(true);
      }
      if (showProgressPage == true)
        startValidationProccessing(uploadedControlIDs.join(","), uploadedControlIDs, isSPFileUpload);
    }
  }, [uploadedControlIDs, uploadPercentage, startProcessImmediately, showProgressPage]);
  const progress = uploadPercentage[rowData.engagementId] || {}; // fallback if undefined
  const [frozenPercent, setFrozenPercent] = useState(progress.percent || 0);

  /* istanbul ignore next */
  useEffect(() => {
    if (isUploadPaused || isUploadAutoPaused) {
      setFrozenPercent(progress.percent); // Freeze the current percent value
    }
  }, [isUploadPaused, isUploadAutoPaused]);

  useEffect(() => {
    const spFiles = files.filter(file => file?.isSPFile);
    const dragFiles = files.filter(file => !file?.isSPFile);
    const spFilesSizeGB = spFiles.reduce((total, file) => total + (Number(file.size) || 0), 0) / (1024 * 1024 * 1024);
    const dragFilesSizeGB = dragFiles.reduce((total, file) => total + (Number(file.size) || 0), 0) / (1024 * 1024 * 1024);
    const allFilesSizeGB = spFilesSizeGB + dragFilesSizeGB;
    // Use correct threshold for allFilesSizeGB (e.g., 2GB)
    if (spFilesSizeGB > 50 || allFilesSizeGB > 50 || files.length === 0) {
      setIsUploadDisabled(true);
    } else if (spFilesSizeGB <= 50 && allFilesSizeGB <= 50 && files.length > 0) {
      setIsUploadDisabled(false);
    }
  }, [files]);

  return (
    <>
      {showProgressPage && progress.percent < 100 && <NetworkStatus useToast={true} />}
      <div className="ey-owned-uploader">
        {/* istanbul ignore next */ showProcessingPage && progress.percent == 100 && !isUploadPaused && !isUploadAutoPaused ? (<>
          <div className="progress-page">
            <div className="progress-container">
              <ProgressCircle
                percentage={
                  isSPFileUpload
                    ? progress.uploadedCount > 1 && totalFileProcessed > 0
                      ? Math.floor(((totalFileProcessed) / (totalFileUploaded)) * 100)
                      : 0
                    : totalFileProcessed > 0
                      ? Math.floor(((totalFileProcessed - progress.failedCount) / totalFileUploaded) * 100)
                      : 0
                }
                uploadedFiles={isSPFileUpload ? Math.max(totalFileProcessed, 0) : Math.min(totalFileProcessed, progress.uploadedCount)}
                totalFiles={progress.uploadedCount}
                failedCount={progress.failedCount}
                processingErrorStatus={processingErrorStatus}
              />
              {/* } */}
              <p>
                <strong>
                  {" "}
                  {progress.uploadedCount}{" "}
                  {progress.uploadedCount === 1
                    ? "Uploaded file is"
                    : "Uploaded files are"}{" "}
                  processing
                </strong>
              </p>
              <p style={{ marginTop: "0px" }}>This may take some time</p>
            </div>

          </div>
          <div style={{ marginLeft: "auto" }}>
            <MotifButton variant="primary" onClick={onClose} disabled={true}>
              Continue
            </MotifButton>
          </div>

        </>
        ) : /* istanbul ignore next */ showProgressPage ? (
          <div className="progress-page">
            <div className="progress-container">
              <ProgressCircle
                percentage={isUploadPaused || isUploadAutoPaused ? frozenPercent : progress.percent || 0}
                totalFiles={originalTotalCountRef.current || progress.totalCount || 0}
                uploadedFiles={isUploadPaused || isUploadAutoPaused ? engagementPauseStatus.current[rowData.engagementId].uploadCount : (progress.failedCount > 0 ? Math.max(0, progress.totalCount - progress.failedCount) : progress.uploadedCount || 0)}
                failedCount={progress.failedCount || 0}
                processingErrorStatus={processingErrorStatus}
              />
              <div className="progress-message">
                {progress.percent >= 100 && !isUploadPaused && !isUploadAutoPaused ? (
                  failedUploads.filter((item) => item.currentFlow === true)
                    .length < 1 ? (
                    <>
                      <p>
                        <strong>
                          {/* {" "}
                        {progress.failedCount > 0 ? (progress.totalCount - progress.failedCount) : progress.uploadedCount}{" "}
                        {(progress.failedCount > 0
                          ? (progress.totalCount - progress.failedCount)
                          : progress.uploadedCount) === 1
                          ? "file is"
                          : "files are"}{" "}
                        Uploaded and processed */}
                          {(() => {
                            const uploadedAndProcessed =
                              progress.failedCount > 0
                                ? Math.max(0, progress.totalCount - progress.failedCount)
                                : progress.uploadedCount;

                            return `${uploadedAndProcessed} ${uploadedAndProcessed > 1 ? "files are" : "file is"
                              } Uploaded and processed`;
                          })()}
                        </strong>
                      </p>
                      {allProtectedFiles.length < 1 && <p>You can close the window.</p>}
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          width: "100%",
                          margin: "0%",
                          maxHeight: "300px",
                          overflowY: "auto",
                        }}
                      >
                        <>
                          <div
                            style={{
                              width: "100%",
                              margin: "0%",
                              maxHeight: "600px",
                              overflowY: "auto",
                            }}
                          >
                            <div>
                              {progress.totalCount !== undefined &&
                                progress.failedCount !== 0 && (
                                  <span>
                                    {Math.max(0, progress.totalCount - progress.failedCount)}{" "}
                                    {Math.max(0, progress.totalCount - progress.failedCount) < 2
                                      ? "file is"
                                      : "files are"}{" "}
                                    uploaded
                                  </span>
                                )}
                            </div>
                            <div>
                              {progress.totalCount !== undefined &&
                                // progress.uploadedCount !== progress.totalCount &&
                                progress.failedCount > 0 && (
                                  <span
                                    style={{ fontSize: "11px", color: "red" }}
                                  >
                                    {initialFailedCountRef.current || progress.failedCount}{" "}
                                    {(initialFailedCountRef.current || progress.failedCount) === 1
                                      ? "file"
                                      : "files are"}{" "}
                                    failed !
                                  </span>
                                )}
                            </div>
                          </div>
                        </>
                        <FailedUploadsList
                          variant="custom-no-margin"
                          showProgressBar={false}
                          setFailedUploadLoadData={setFailedUploadLoadData}
                          isFailedUploadLoadData={isFailedUploadLoadData}
                          uploadingFileId={uploadingFileId}
                          failedUploadData={failedUploadData}
                          uploadingFileIds={uploadingFileIds}
                          failedUploads={failedUploads.filter(
                            (item) => item.currentFlow === true
                          )}
                          selectedFileIds={selectedFiles}
                          onToggleSelect={handleToggleSelect}
                          onToggleSelectAll={handleToggleSelectAll}
                          onDelete={handleDelete}
                          onReupload={handleReupload}
                          onBulkDelete={handleDelete}
                          onBulkReupload={handleReuploadAll}
                          showTopRow={false}
                          disableCloseButton={showProgressBarFailedUpload}
                          failedDeleteLoading={failedDeleteLoading}
                          setFailedDeleteLoading={setFailedDeleteLoading}
                          processingMsg={processingMsg}
                        />
                        {failedUploads.length > 0 && (
                          <>
                            <p
                              className="upload-message"
                              style={{ padding: "0px" }}
                            >
                              You can upload it now or continue to do it later.
                            </p>
                            <p className="upload-message" style={{ padding: "0px" }}>
                              You'll have 3 attempts to reupload.
                            </p>
                          </>
                        )}
                      </div>
                    </>
                  )
                ) : (
                  <>
                    <img
                      loading="lazy"
                      src={
                        isUploadPaused || isUploadAutoPaused
                          ? require("../../common/images/resume.png")
                          : require("../../common/images/pause.png")
                      }
                      onClick={() => { handleUploadProgress(rowData.engagementId); }}
                      alt={isUploadPaused || isUploadAutoPaused ? "Resume" : "Pause"}
                      style={{ height: 26 }}
                    />
                    <p>
                      <strong>
                        {" "}
                        We are uploading {progress.totalCount}{" "}
                        {progress.totalCount === 1 ? "File" : "Files"}...{" "}
                      </strong>
                    </p>
                    <p>Uploading continues - you may close the window.</p>
                  </>
                )}
              </div>

            </div>
            <div
              className="upload-close-button-container"
              style={{ bottom: "-60px", right: "0px" }}
            >
              <MotifButton
                variant="primary"
                onClick={() => {
                  if (allProtectedFiles.length > 0) {
                    setShowProgressPage(false);
                    SetUploadComplete(true);
                  } else {
                    onClose();
                  }
                }}
                disabled={progress.percent !== 100 || disableContinue}
              >
                {allProtectedFiles.length > 0 ||
                  progress.percent !== 100 ||
                  (progress.percent == 100 && failedUploads.length > 0 && allProtectedFiles.length > 0)
                  ? "Continue"
                  : "Close"}
              </MotifButton>
            </div>
          </div>
        ) : isLoading || isUnlocking ? (
          <MotifProgressLoader show variant="default" />
        ) : openFailedUploadBadge ? (
          <>
            <div style={{ width: "100%", margin: "0%" }}>
              <FailedUploadsList
                variant="custom-no-margin"
                setFailedUploadLoadData={setFailedUploadLoadData}
                isFailedUploadLoadData={isFailedUploadLoadData}
                showProgressBar={showProgressBar}
                failedUploadData={failedUploadData}
                uploadingFileId={uploadingFileId}
                uploadingFileIds={uploadingFileIds}
                failedUploads={failedUploads}
                selectedFileIds={selectedFiles}
                onToggleSelect={handleToggleSelect}
                onToggleSelectAll={handleToggleSelectAll}
                onDelete={handleDelete}
                onReupload={handleReupload}
                onBulkDelete={handleDelete} // ✅ Add this
                onBulkReupload={handleReuploadAll}
                showUploadData={showUploadData}
                showTopRow={true}
                disableCloseButton={showProgressBarFailedUpload}
                failedDeleteLoading={failedDeleteLoading}
                setFailedDeleteLoading={setFailedDeleteLoading}
                processingMsg={processingMsg}
              />
              {failedUploads.length > 0 && (
                <>
                  <p className="upload-message" style={{ padding: "0px" }}>
                    You can upload it now or continue to do it later.
                  </p>
                </>
              )}
            </div>
            <div style={{ marginLeft: "auto" }}>
              <MotifButton variant="primary" onClick={onClose} disabled={isActive}>
                Close
              </MotifButton>
            </div>
          </>
        ) : /* istanbul ignore next */ uploadComplete && !showProgressPage ? (
          <ProtectedFilesDisplay
            allProtectedFiles={allProtectedFiles}
            setAllProtectedFiles={setAllProtectedFiles}
            removeFile={removeFile}
            setPasswords={setPasswords}
            setIsCorrectPasswords={setIsCorrectPasswords}
            showErrorMessage={showErrorMessage}
            setshowErrorMessage={setshowErrorMessage}
            passwords={passwords}
            isContinueClicked={isContinueClicked}
            handleSkipAndContinueClick={handleSkipAndContinueClick}
            handleUploadClick={handleUploadClick}
            setProtectedFiles={setProtectedFiles}
            navigateToFolder={navigateToFolder}
            countFilesRecursively={countFilesRecursively}
            getCurrentFolderContents={getCurrentFolderContents}
            currentPath={currentPath}
            setCurrentPath={setCurrentPath}
            fileStructure={fileStructure}
            goBack={goBack}
            baseURL={baseURL}
            isUploadDisabled={isUploadDisabled}
            handleFolderUnlock={handleFolderUnlock}
            extractedFiles={extractedFiles}
            fileProtectionStatuss={fileProtectionStatus}
            setFileProtectionStatuss={setFileProtectionStatus}
            isClientEngagement={isClientEngagement}
            handleRemoveFile={handleRemoveFile}
            rowData={rowData}
            triggerEngagementUpdate={triggerEngagementUpdate}
            setIsUploading={setIsUploading}
            onClose={onClose}
            isCorrectPassword={isCorrectPassword}
            setIsCorrectPassword={setIsCorrectPassword}
            showError={showError}
            setShowError={setShowError}
            setIsUnlocking={setIsUnlocking}
            UPLOADID_GUID={UPLOADID_GUID}

          />
        ) : (
          // Render the file uploader interface
          nextPwdPage ?
            <>

              <div className="file-upload">
                <MotifFormField>
                  <MotifFileUploader
                    id="my-id"
                    label={
                      <>
                        <span className="bold-small">
                          Click to attach or drag and drop
                        </span>
                        <br />
                        <span className="normal-small">
                          Maximum size up to 50GB (File Limit - 1500)
                        </span>
                      </>
                    }
                    onDrop={onDrop}
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    reactive
                    className={isDragging ? "highlighted" : ""}
                  ></MotifFileUploader>
                  <MotifLabel className="label">SharePoint URL<span style={{ fontSize: '12px' }}>(Maximum size up to 50GB)</span></MotifLabel>
                  <MotifFormField
                    label="SharePoint URL"
                    className="sharepoint-url-container"
                  >
                    <div className="input-with-icon">
                      <MotifIcon
                        src={sharePointIcon}
                        className="input-icon"
                      ></MotifIcon>
                      <MotifInput
                        aria-label="SharePoint URL"
                        placeholder="Paste link here"
                        value={sharePointURL}
                        onChange={(e) => {
                          setSharePointURL(e.target.value.trim());
                        }}
                      />
                    </div>
                    <MotifButton
                      variant="secondary"
                      onClick={handleSPProceedClick}
                      disabled={!sharePointURL.trim() || (!SPAccess) || (spFilesSizeGB > 50)}
                    >
                      {isSPLoading ? <SmallCircleLoader /> : buttonLabel}
                    </MotifButton>
                  </MotifFormField>
                </MotifFormField>
                {isToastVisible && (
                  <div className="sp-toast-container">
                  <MotifToast
                  variant="success"
                  className="sharepoint-url-toast"
                  onClose={() => setIsToastVisible(false)} // Close toast on click
                >
                  <div>
                    This link is valid.
                  </div>
                </MotifToast>
                </div>)}
                {(spFilesSizeGB > 50) && (
                  <div className="storage-limit-warning">
                    Maximum file size exceeded. Upload up to 50GB
                  </div>
                )}
                {SPAccess === false && (
                  <MotifErrorMessage>
                    You do not have the required permissions to access this link.
                  </MotifErrorMessage>
                )}
                {SPAccess && <SelectSharePoint
                  open={openDialogbox}
                  onClose={() => setOpenDialogbox(false)}
                  setSPPayload={setSPPayload}
                  SetSelectedSPFiles={SetSelectedSPFiles}
                  SetHandleAttach={SetHandleAttach}
                  rowData={rowData}
                  sharePointFiles={sharePointFiles}
                  isSPLoading={isSPLoading}
                />}
              </div>

              {files?.length > 0 && !fileEvaluatingMsg && (
                <div className="add-files-search-container">
                  <MotifFormField>
                    <MotifSearch
                      aria-label="Search"
                      onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
                      placeholder="Search..."
                      value={searchValue}
                    />
                  </MotifFormField>
                </div>
              )}

              {fileEvaluatingMsg ? (
                <div>
                  <MotifProgressBar
                    labelPosition="default"
                    processStateLabel="Loading..."
                    resultStateLabel=""
                    isIndeterminate={true}
                    variant="alt"
                    value={evaluationProgress}
                    // circle={true}
                    // hideLabel={true}
                    size="sm"
                  // className='file-progressbar' // Ensure to apply your existing styles
                  />
                  <span className="file-progressbar">
                    The files are being evaluated, please wait...
                  </span>
                </div>
              ) : (
                <div className="file-list-container">
                  {shoWBreadcrumb && (
                    <div className="file-list-breadcrumb">
                      <BreadcrumbNavigation
                        currentPath={currentPath}
                        goBack={goBack}
                        isClientEngagement={isClientEngagement}
                      />
                    </div>
                  )}
                  {(() => {
                    const isSearching = (searchValue || "").trim().length > 0;

                    if (isSearching) {
                      const term = searchValue.toLowerCase();
                      const searchSource =
                        isContinueClicked && protectedFiles.length && !isSkipContinueClicked
                          ? protectedFiles
                          : [...files, ...extractedFiles];

                      const results = searchSource.filter((f) =>
                        (f?.name || "").toLowerCase().includes(term)
                      );

                      if (results.length === 0) {
                        return (
                          <div className="no-search-results-message">
                            <span>No Files to View</span>
                          </div>
                        );
                      }

                      return results.map((file, index) => (
                        <FileTile
                          key={`${file.name}-${file.path || index}`}
                          file={file}
                          isFileProtected={fileProtectionStatus[file.path]}
                          removeFile={() => removeFile(file.path, true)}
                          isContinueClicked={isContinueClicked}
                          onRemoveProtectedFile={onRemoveProtectedFile}
                          passwords={passwords}
                          fileTypeName={File}
                          baseURL={baseURL}
                          allowDelete={true}
                          setIsLoading={setIsLoading}
                          searchValue={searchValue}
                        />
                      ));
                    }

                    // Default (not searching): original folder + file view
                    return Object.entries(getCurrentFolderContents())
                      .filter(
                        ([name]) =>
                          ![
                            "isPartZip",
                            "path",
                            "error",
                            "isLocked",
                            "name",
                            "lastModified",
                            "content",
                            "password",
                            "isFileLocked",
                            "isFileProtected",
                          ].includes(name)
                      )
                      // .filter(([name]) => name.toLowerCase().includes(searchValue.toLowerCase())) // Add this line for filtering
                      .map(([name, content], index) => {
                        let isExtracted = false;
                        let allowDelete = content.isPartZip
                          ? !content.isPartZip
                          : true;

                        let showZipAsFile = false;

                        if (
                          typeof content === "object" &&
                          name.endsWith(".zip") &&
                          fileProtectionStatus[content.path]
                        ) {
                          showZipAsFile = true; //!extractedFiles.some(item => item.path.startsWith(content.path + "/"));
                        }
                        // Check if content is already a File or contains { file, path }
                        if (typeof content === "object" && "file" in content) {
                          isExtracted = true;
                        }

                        //if (((isExtracted ? content.file : content) instanceof File && !name.endsWith(".zip")) || showZipAsFile) {
                        if (content instanceof File || content.size) {
                          return (
                            <FileTile
                              key={index}
                              file={isExtracted ? content.file : content}
                              isFileProtected={fileProtectionStatus[content.path]}
                              removeFile={() => removeFile(content.path, true)}
                              isContinueClicked={isContinueClicked}
                              onRemoveProtectedFile={onRemoveProtectedFile}
                              passwords={passwords}
                              fileTypeName={File}
                              baseURL={baseURL}
                              allowDelete={allowDelete}
                              setIsLoading={setIsLoading}
                              searchValue={searchValue}
                            />
                          );
                        }
                        const fileCount = countFilesRecursively(
                          isExtracted ? content.file : content
                        );
                        const isFolderProtected = content.isLocked;
                        const isZip = name.endsWith(".zip") ? true : false;
                        return (
                          <div className="ft-file-item">
                            <div className="ft-file-icon">
                              <img
                                loading="lazy"
                                src={
                                  isZip
                                    ? require("../../common/images/zip.png")
                                    : require("../../common/images/folder.png")
                                }
                                alt={isZip ? "ZIP file icon" : "Folder icon"}
                              />
                            </div>
                            <div className="ft-file-details">
                              <div
                                className="ft-file-name cursor-pointer"
                                key={name}
                                title={name}
                              >
                                <div
                                  className="ft-file-name-text"
                                  onClick={() => navigateToFolder(name)}
                                >
                                  {name}
                                </div>
                                  <div className="ft-file-type">
                           <span className="spn-file-type-label">  Type:</span>{isZip ? "ZIP File" : "Folder"}, {fileCount}{" "}
                                Files
                              </div>
                              </div>
                              {/* <div className="ft-file-type">
                           <span style={{fontWeight:500}}>   Type:</span>   {isZip ? "ZIP File" : "Folder"}, {fileCount}{" "}
                                Files
                              </div> */}
                              {/* showProgress && */}

                              <div className="ft-file-actions">
                                {isFolderProtected && (
                                  <MotifIcon
                                    src={lockIcon}
                                    className={
                                      showProgress
                                        ? "ft-file-lock-icon-padding"
                                        : "ft-file-lock-icon"
                                    }
                                  />
                                )}
                                {allowDelete && (
                                  <button
                                    className={
                                      showProgress
                                        ? "ft-file-remove-padding"
                                        : "ft-file-remove"
                                    }
                                    onClick={() =>
                                      removeFile(content.path ? content.path : name)
                                    }
                                  >
                                    {/* <MotifIcon src={deleteIcon} /> */}
                                     <img
                    src={require("../../common/images/trash.svg").default}
                    alt="Delete-icon"
                    style={{ maxWidth:"93%" }}
                     
                  />
                                  </button>
                                )}
                              </div>

                            </div>
                          </div>
                        );
                      });
                  })()}

                </div>
              )}

              <div className="uploader-actions">
                <MotifButton variant="secondary" onClick={onClose}>
                  Cancel
                </MotifButton>
                <MotifButton
                  variant="primary"
                  //  onClick={handleUploadClick}
                  onClick={() => { setNextPwdPage(false); onClientDataChange(false); }}
                  disabled={isUploadDisabled}
                >
                  {hasProtectedFiles ? "Continue" : (files.length < 1 ? "Upload" : "Continue")}
                </MotifButton>
              </div>
            </> : <>
              <div className='common-level-pwd-container'>
                <div
                  className='common-level-pwd-container__grey-lock-icon'
                >
                  <MotifIcon src={greyLockIcon} alt='Lock Icon' />
                </div>
                <div className='common-level-pwd-container__heading-one'>
                  We need the password to upload the locked files
                </div>
                <div className='common-level-pwd-container__heading-two'>
                  You can enter your ‘engagement-level password’ now or choose to provide later.
                </div>
                <MotifFormField className='common-level-pwd-container__form'>
                  <MotifLabel className='common-level-pwd-container__label' >Enter common engagement-level password</MotifLabel>
                  <MotifFormField
                    className="common-level-pwd-container__field"
                  >
                    <div className="input-with-icon">
                      <MotifIcon
                        src={passwordCursorIcon}
                        className="input-icon"
                      ></MotifIcon>
                      <MotifInput
                        // onClose={() => setShwCheckCircle(false)}
                        aria-label="Password"
                        placeholder="Password (required)"
                        value={engLevelPwd.trim()}
                        onChange={(e) => {
                          setEngLevelPwd(e.target.value);
                          const process = initiateAutoProcess.current.find(
                            (p) => p.engID === rowData.engagementId
                          );
                          if (process) {
                            process.engLevelPwd = e.target.value;

                          }
                          else {
                            initiateAutoProcess.current.push({
                              engID: rowData.engagementId,
                              engLevelPwd: e.target.value
                            });
                          }
                        }}

                        type={isEngLevelPasswordVisible ? 'text' : 'password'}
                        hideClearButton={true}
                      />

                    </div>
                    {engLevelPwd.length > 0 && (
                      <button className="ft-eng-password-toggle" onClick={() => setIsEngLevelPasswordVisible(!isEngLevelPasswordVisible)}>
                        <MotifIcon src={isEngLevelPasswordVisible ? eyeCloseIcon : eyeIcon} />
                      </button>
                    )}
                  </MotifFormField>
                </MotifFormField>
              </div>

              <div className="uploader-actions">
                <MotifButton variant="secondary" onClick={() => { pwdSkipped.current = true; getDuplicateFilesData() }}>
                  Skip & Upload
                </MotifButton>
                <MotifButton
                  variant="primary"
                  onClick={getDuplicateFilesData}
                  disabled={isUploadDisabled || engLevelPwd.length < 1}
                >
                  Save & Upload
                </MotifButton>
              </div>
            </>
        )}
        
        {/* istanbul ignore next */}
        <Dialog
          open={openDuplicateDialog}
          onClose={() => setOpenDuplicateDialog(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>
            <IconButton
              onClick={() => setOpenDuplicateDialog(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>

          </DialogTitle>
          <DialogContent dividers className="modal-content">

            <>
              {
                // files.some(file => file.name.toLowerCase().endsWith(".zip")) ? (
                //   <>
                //     <strong>Files with the same name will be overwritten.</strong>
                //     <p>Do you want to proceed?</p>
                //     <p>
                //       <em>Note: Files that have already been processed will be discarded.</em>
                //     </p>
                //   </>
                // ) :
                (submittedDuplicateFiles.current &&
                  nonsubmittedDuplicateFiles.current) || files.some(file => file.name.toLowerCase().endsWith(".zip")) ?
                  (
                    <>
                      <strong>Files with the same name will be overwritten.</strong>
                      <p>Do you want to proceed?</p>
                      <p>
                        <em>Note: Files that have already been processed will be discarded.</em>
                      </p>
                    </>
                  ) : submittedDuplicateFiles.current && !nonsubmittedDuplicateFiles.current ? (
                    <strong>Files that have already been processed will be discarded.</strong>
                  ) : !submittedDuplicateFiles.current && nonsubmittedDuplicateFiles.current ? (
                    <>
                      <strong>Files with the same name will be overwritten.</strong>
                      <p>Do you want to proceed?</p>
                    </>
                  ) : null}
            </>



          </DialogContent>



          <DialogActions>
            {submittedDuplicateFiles.current && !nonsubmittedDuplicateFiles.current && files.filter(file => file.name.toLowerCase().endsWith(".zip")).length == 0 ? (
              <>
                <MotifButton
                  onClick={() => handleDuplicateConfirmation(false)}
                  color="primary"
                  autoFocus
                >
                  Ok
                </MotifButton>
              </>
            ) : (
              <>

                <MotifButton
                  onClick={() => handleDuplicateConfirmation(false)}
                  color="primary"
                  autoFocus
                >
                  No, keep existing files
                </MotifButton>

                <MotifButton
                  onClick={() => handleDuplicateConfirmation(true)}
                  color="primary"
                  autoFocus
                >
                  Yes, overwrite all
                </MotifButton>
              </>
            )}
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};
export default ClientEngagementUploader;